/*

To avoid repetive calls to server, JS file taken from https://assets.sitescdn.net/answers-search-bar/v1.0/answerstemplates.compiled.min.js

*/

!(function (e, t) {
	"object" == typeof exports && "undefined" != typeof module
		? t(exports)
		: "function" == typeof define && define.amd
		? define(["exports"], t)
		: t(((e = e || self).TemplateBundle = {}));
})(this, function (e) {
	"use strict";
	var t =
		"undefined" != typeof globalThis
			? globalThis
			: "undefined" != typeof window
			? window
			: "undefined" != typeof global
			? global
			: "undefined" != typeof self
			? self
			: {};
	function n(e) {
		return e &&
			e.__esModule &&
			Object.prototype.hasOwnProperty.call(e, "default")
			? e.default
			: e;
	}
	function r(e, t) {
		return e((t = { exports: {} }), t.exports), t.exports;
	}
	function o(e) {
		return (e && e.default) || e;
	}
	var a,
		l,
		i = function (e) {
			return e && e.Math == Math && e;
		},
		u =
			i("object" == typeof globalThis && globalThis) ||
			i("object" == typeof window && window) ||
			i("object" == typeof self && self) ||
			i("object" == typeof t && t) ||
			(function () {
				return this;
			})() ||
			Function("return this")(),
		c = function (e) {
			try {
				return !!e();
			} catch (e) {
				return !0;
			}
		},
		s = !c(function () {
			return (
				7 !=
				Object.defineProperty({}, 1, {
					get: function () {
						return 7;
					}
				})[1]
			);
		}),
		p = {}.propertyIsEnumerable,
		f = Object.getOwnPropertyDescriptor,
		d = {
			f:
				f && !p.call({ 1: 2 }, 1)
					? function (e) {
							var t = f(this, e);
							return !!t && t.enumerable;
					  }
					: p
		},
		h = function (e, t) {
			return {
				enumerable: !(1 & e),
				configurable: !(2 & e),
				writable: !(4 & e),
				value: t
			};
		},
		m = {}.toString,
		y = function (e) {
			return m.call(e).slice(8, -1);
		},
		v = "".split,
		g = c(function () {
			return !Object("z").propertyIsEnumerable(0);
		})
			? function (e) {
					return "String" == y(e) ? v.call(e, "") : Object(e);
			  }
			: Object,
		x = function (e) {
			if (null == e) throw TypeError("Can't call method on " + e);
			return e;
		},
		b = function (e) {
			return g(x(e));
		},
		w = function (e) {
			return "object" == typeof e ? null !== e : "function" == typeof e;
		},
		O = function (e, t) {
			if (!w(e)) return e;
			var n, r;
			if (t && "function" == typeof (n = e.toString) && !w((r = n.call(e))))
				return r;
			if ("function" == typeof (n = e.valueOf) && !w((r = n.call(e)))) return r;
			if (!t && "function" == typeof (n = e.toString) && !w((r = n.call(e))))
				return r;
			throw TypeError("Can't convert object to primitive value");
		},
		P = {}.hasOwnProperty,
		S = function (e, t) {
			return P.call(e, t);
		},
		_ = u.document,
		j = w(_) && w(_.createElement),
		k = function (e) {
			return j ? _.createElement(e) : {};
		},
		I =
			!s &&
			!c(function () {
				return (
					7 !=
					Object.defineProperty(k("div"), "a", {
						get: function () {
							return 7;
						}
					}).a
				);
			}),
		T = Object.getOwnPropertyDescriptor,
		C = {
			f: s
				? T
				: function (e, t) {
						if (((e = b(e)), (t = O(t, !0)), I))
							try {
								return T(e, t);
							} catch (e) {}
						if (S(e, t)) return h(!d.f.call(e, t), e[t]);
				  }
		},
		M = /#|\.prototype\./,
		E = function (e, t) {
			var n = N[A(e)];
			return n == B || (n != L && ("function" == typeof t ? c(t) : !!t));
		},
		A = (E.normalize = function (e) {
			return String(e).replace(M, ".").toLowerCase();
		}),
		N = (E.data = {}),
		L = (E.NATIVE = "N"),
		B = (E.POLYFILL = "P"),
		H = E,
		D = {},
		F = function (e, t, n) {
			if (
				((function (e) {
					if ("function" != typeof e)
						throw TypeError(String(e) + " is not a function");
				})(e),
				void 0 === t)
			)
				return e;
			switch (n) {
				case 0:
					return function () {
						return e.call(t);
					};
				case 1:
					return function (n) {
						return e.call(t, n);
					};
				case 2:
					return function (n, r) {
						return e.call(t, n, r);
					};
				case 3:
					return function (n, r, o) {
						return e.call(t, n, r, o);
					};
			}
			return function () {
				return e.apply(t, arguments);
			};
		},
		R = function (e) {
			if (!w(e)) throw TypeError(String(e) + " is not an object");
			return e;
		},
		V = Object.defineProperty,
		q = {
			f: s
				? V
				: function (e, t, n) {
						if ((R(e), (t = O(t, !0)), R(n), I))
							try {
								return V(e, t, n);
							} catch (e) {}
						if ("get" in n || "set" in n)
							throw TypeError("Accessors not supported");
						return "value" in n && (e[t] = n.value), e;
				  }
		},
		U = s
			? function (e, t, n) {
					return q.f(e, t, h(1, n));
			  }
			: function (e, t, n) {
					return (e[t] = n), e;
			  },
		G = C.f,
		W = function (e) {
			var t = function (t, n, r) {
				if (this instanceof e) {
					switch (arguments.length) {
						case 0:
							return new e();
						case 1:
							return new e(t);
						case 2:
							return new e(t, n);
					}
					return new e(t, n, r);
				}
				return e.apply(this, arguments);
			};
			return (t.prototype = e.prototype), t;
		},
		z = function (e, t) {
			var n,
				r,
				o,
				a,
				l,
				i,
				c,
				s,
				p = e.target,
				f = e.global,
				d = e.stat,
				h = e.proto,
				m = f ? u : d ? u[p] : (u[p] || {}).prototype,
				y = f ? D : D[p] || (D[p] = {}),
				v = y.prototype;
			for (o in t)
				(n = !H(f ? o : p + (d ? "." : "#") + o, e.forced) && m && S(m, o)),
					(l = y[o]),
					n && (i = e.noTargetGet ? (s = G(m, o)) && s.value : m[o]),
					(a = n && i ? i : t[o]),
					(n && typeof l == typeof a) ||
						((c =
							e.bind && n
								? F(a, u)
								: e.wrap && n
								? W(a)
								: h && "function" == typeof a
								? F(Function.call, a)
								: a),
						(e.sham || (a && a.sham) || (l && l.sham)) && U(c, "sham", !0),
						(y[o] = c),
						h &&
							(S(D, (r = p + "Prototype")) || U(D, r, {}),
							(D[r][o] = a),
							e.real && v && !v[o] && U(v, o, a)));
		},
		Q =
			Array.isArray ||
			function (e) {
				return "Array" == y(e);
			},
		J = function (e) {
			return Object(x(e));
		},
		Y = Math.ceil,
		X = Math.floor,
		K = function (e) {
			return isNaN((e = +e)) ? 0 : (e > 0 ? X : Y)(e);
		},
		Z = Math.min,
		$ = function (e) {
			return e > 0 ? Z(K(e), 9007199254740991) : 0;
		},
		ee = function (e, t, n) {
			var r = O(t);
			r in e ? q.f(e, r, h(0, n)) : (e[r] = n);
		},
		te =
			u["__core-js_shared__"] ||
			(function (e, t) {
				try {
					U(u, e, t);
				} catch (n) {
					u[e] = t;
				}
				return t;
			})("__core-js_shared__", {}),
		ne = r(function (e) {
			(e.exports = function (e, t) {
				return te[e] || (te[e] = void 0 !== t ? t : {});
			})("versions", []).push({
				version: "3.9.1",
				mode: "pure",
				copyright: "Â© 2021 Denis Pushkarev (zloirock.ru)"
			});
		}),
		re = 0,
		oe = Math.random(),
		ae = function (e) {
			return (
				"Symbol(" +
				String(void 0 === e ? "" : e) +
				")_" +
				(++re + oe).toString(36)
			);
		},
		le = "process" == y(u.process),
		ie = function (e) {
			return "function" == typeof e ? e : void 0;
		},
		ue = function (e, t) {
			return arguments.length < 2
				? ie(D[e]) || ie(u[e])
				: (D[e] && D[e][t]) || (u[e] && u[e][t]);
		},
		ce = ue("navigator", "userAgent") || "",
		se = u.process,
		pe = se && se.versions,
		fe = pe && pe.v8;
	fe
		? (l = (a = fe.split("."))[0] + a[1])
		: ce &&
		  (!(a = ce.match(/Edge\/(\d+)/)) || a[1] >= 74) &&
		  (a = ce.match(/Chrome\/(\d+)/)) &&
		  (l = a[1]);
	var de,
		he = l && +l,
		me =
			!!Object.getOwnPropertySymbols &&
			!c(function () {
				return !Symbol.sham && (le ? 38 === he : he > 37 && he < 41);
			}),
		ye = me && !Symbol.sham && "symbol" == typeof Symbol.iterator,
		ve = ne("wks"),
		ge = u.Symbol,
		xe = ye ? ge : (ge && ge.withoutSetter) || ae,
		be = function (e) {
			return (
				(S(ve, e) && (me || "string" == typeof ve[e])) ||
					(me && S(ge, e) ? (ve[e] = ge[e]) : (ve[e] = xe("Symbol." + e))),
				ve[e]
			);
		},
		we = be("species"),
		Oe = function (e, t) {
			var n;
			return (
				Q(e) &&
					("function" != typeof (n = e.constructor) ||
					(n !== Array && !Q(n.prototype))
						? w(n) && null === (n = n[we]) && (n = void 0)
						: (n = void 0)),
				new (void 0 === n ? Array : n)(0 === t ? 0 : t)
			);
		},
		Pe = be("species"),
		Se = be("isConcatSpreadable"),
		_e =
			he >= 51 ||
			!c(function () {
				var e = [];
				return (e[Se] = !1), e.concat()[0] !== e;
			}),
		je =
			((de = "concat"),
			he >= 51 ||
				!c(function () {
					var e = [];
					return (
						((e.constructor = {})[Pe] = function () {
							return { foo: 1 };
						}),
						1 !== e[de](Boolean).foo
					);
				})),
		ke = function (e) {
			if (!w(e)) return !1;
			var t = e[Se];
			return void 0 !== t ? !!t : Q(e);
		};
	z(
		{ target: "Array", proto: !0, forced: !_e || !je },
		{
			concat: function (e) {
				var t,
					n,
					r,
					o,
					a,
					l = J(this),
					i = Oe(l, 0),
					u = 0;
				for (t = -1, r = arguments.length; t < r; t++)
					if (ke((a = -1 === t ? l : arguments[t]))) {
						if (u + (o = $(a.length)) > 9007199254740991)
							throw TypeError("Maximum allowed index exceeded");
						for (n = 0; n < o; n++, u++) n in a && ee(i, u, a[n]);
					} else {
						if (u >= 9007199254740991)
							throw TypeError("Maximum allowed index exceeded");
						ee(i, u++, a);
					}
				return (i.length = u), i;
			}
		}
	);
	var Ie,
		Te = Object.freeze({ __proto__: null }),
		Ce = Math.max,
		Me = Math.min,
		Ee = function (e) {
			return function (t, n, r) {
				var o,
					a = b(t),
					l = $(a.length),
					i = (function (e, t) {
						var n = K(e);
						return n < 0 ? Ce(n + t, 0) : Me(n, t);
					})(r, l);
				if (e && n != n) {
					for (; l > i; ) if ((o = a[i++]) != o) return !0;
				} else
					for (; l > i; i++)
						if ((e || i in a) && a[i] === n) return e || i || 0;
				return !e && -1;
			};
		},
		Ae = { includes: Ee(!0), indexOf: Ee(!1) },
		Ne = {},
		Le = Ae.indexOf,
		Be = function (e, t) {
			var n,
				r = b(e),
				o = 0,
				a = [];
			for (n in r) !S(Ne, n) && S(r, n) && a.push(n);
			for (; t.length > o; ) S(r, (n = t[o++])) && (~Le(a, n) || a.push(n));
			return a;
		},
		He = [
			"constructor",
			"hasOwnProperty",
			"isPrototypeOf",
			"propertyIsEnumerable",
			"toLocaleString",
			"toString",
			"valueOf"
		],
		De =
			Object.keys ||
			function (e) {
				return Be(e, He);
			},
		Fe = s
			? Object.defineProperties
			: function (e, t) {
					R(e);
					for (var n, r = De(t), o = r.length, a = 0; o > a; )
						q.f(e, (n = r[a++]), t[n]);
					return e;
			  },
		Re = ue("document", "documentElement"),
		Ve = ne("keys"),
		qe = function (e) {
			return Ve[e] || (Ve[e] = ae(e));
		},
		Ue = qe("IE_PROTO"),
		Ge = function () {},
		We = function (e) {
			return "<script>" + e + "</script>";
		},
		ze = function () {
			try {
				Ie = document.domain && new ActiveXObject("htmlfile");
			} catch (e) {}
			var e, t;
			ze = Ie
				? (function (e) {
						e.write(We("")), e.close();
						var t = e.parentWindow.Object;
						return (e = null), t;
				  })(Ie)
				: (((t = k("iframe")).style.display = "none"),
				  Re.appendChild(t),
				  (t.src = String("javascript:")),
				  (e = t.contentWindow.document).open(),
				  e.write(We("document.F=Object")),
				  e.close(),
				  e.F);
			for (var n = He.length; n--; ) delete ze.prototype[He[n]];
			return ze();
		};
	Ne[Ue] = !0;
	var Qe =
			Object.create ||
			function (e, t) {
				var n;
				return (
					null !== e
						? ((Ge.prototype = R(e)),
						  (n = new Ge()),
						  (Ge.prototype = null),
						  (n[Ue] = e))
						: (n = ze()),
					void 0 === t ? n : Fe(n, t)
				);
			},
		Je = He.concat("length", "prototype"),
		Ye = {
			f:
				Object.getOwnPropertyNames ||
				function (e) {
					return Be(e, Je);
				}
		},
		Xe = Ye.f,
		Ke = {}.toString,
		Ze =
			"object" == typeof window && window && Object.getOwnPropertyNames
				? Object.getOwnPropertyNames(window)
				: [],
		$e = {
			f: function (e) {
				return Ze && "[object Window]" == Ke.call(e)
					? (function (e) {
							try {
								return Xe(e);
							} catch (e) {
								return Ze.slice();
							}
					  })(e)
					: Xe(b(e));
			}
		},
		et = { f: Object.getOwnPropertySymbols },
		tt = function (e, t, n, r) {
			r && r.enumerable ? (e[t] = n) : U(e, t, n);
		},
		nt = { f: be },
		rt = q.f,
		ot = function (e) {
			var t = D.Symbol || (D.Symbol = {});
			S(t, e) || rt(t, e, { value: nt.f(e) });
		},
		at = {};
	at[be("toStringTag")] = "z";
	var lt = "[object z]" === String(at),
		it = be("toStringTag"),
		ut =
			"Arguments" ==
			y(
				(function () {
					return arguments;
				})()
			),
		ct = lt
			? y
			: function (e) {
					var t, n, r;
					return void 0 === e
						? "Undefined"
						: null === e
						? "Null"
						: "string" ==
						  typeof (n = (function (e, t) {
								try {
									return e[t];
								} catch (e) {}
						  })((t = Object(e)), it))
						? n
						: ut
						? y(t)
						: "Object" == (r = y(t)) && "function" == typeof t.callee
						? "Arguments"
						: r;
			  },
		st = lt
			? {}.toString
			: function () {
					return "[object " + ct(this) + "]";
			  },
		pt = q.f,
		ft = be("toStringTag"),
		dt = function (e, t, n, r) {
			if (e) {
				var o = n ? e : e.prototype;
				S(o, ft) || pt(o, ft, { configurable: !0, value: t }),
					r && !lt && U(o, "toString", st);
			}
		},
		ht = Function.toString;
	"function" != typeof te.inspectSource &&
		(te.inspectSource = function (e) {
			return ht.call(e);
		});
	var mt,
		yt,
		vt,
		gt = te.inspectSource,
		xt = u.WeakMap,
		bt = "function" == typeof xt && /native code/.test(gt(xt)),
		wt = u.WeakMap;
	if (bt) {
		var Ot = te.state || (te.state = new wt()),
			Pt = Ot.get,
			St = Ot.has,
			_t = Ot.set;
		(mt = function (e, t) {
			return (t.facade = e), _t.call(Ot, e, t), t;
		}),
			(yt = function (e) {
				return Pt.call(Ot, e) || {};
			}),
			(vt = function (e) {
				return St.call(Ot, e);
			});
	} else {
		var jt = qe("state");
		(Ne[jt] = !0),
			(mt = function (e, t) {
				return (t.facade = e), U(e, jt, t), t;
			}),
			(yt = function (e) {
				return S(e, jt) ? e[jt] : {};
			}),
			(vt = function (e) {
				return S(e, jt);
			});
	}
	var kt = {
			set: mt,
			get: yt,
			has: vt,
			enforce: function (e) {
				return vt(e) ? yt(e) : mt(e, {});
			},
			getterFor: function (e) {
				return function (t) {
					var n;
					if (!w(t) || (n = yt(t)).type !== e)
						throw TypeError("Incompatible receiver, " + e + " required");
					return n;
				};
			}
		},
		It = [].push,
		Tt = function (e) {
			var t = 1 == e,
				n = 2 == e,
				r = 3 == e,
				o = 4 == e,
				a = 6 == e,
				l = 7 == e,
				i = 5 == e || a;
			return function (u, c, s, p) {
				for (
					var f,
						d,
						h = J(u),
						m = g(h),
						y = F(c, s, 3),
						v = $(m.length),
						x = 0,
						b = p || Oe,
						w = t ? b(u, v) : n || l ? b(u, 0) : void 0;
					v > x;
					x++
				)
					if ((i || x in m) && ((d = y((f = m[x]), x, h)), e))
						if (t) w[x] = d;
						else if (d)
							switch (e) {
								case 3:
									return !0;
								case 5:
									return f;
								case 6:
									return x;
								case 2:
									It.call(w, f);
							}
						else
							switch (e) {
								case 4:
									return !1;
								case 7:
									It.call(w, f);
							}
				return a ? -1 : r || o ? o : w;
			};
		},
		Ct = {
			forEach: Tt(0),
			map: Tt(1),
			filter: Tt(2),
			some: Tt(3),
			every: Tt(4),
			find: Tt(5),
			findIndex: Tt(6),
			filterOut: Tt(7)
		},
		Mt = Ct.forEach,
		Et = qe("hidden"),
		At = be("toPrimitive"),
		Nt = kt.set,
		Lt = kt.getterFor("Symbol"),
		Bt = Object.prototype,
		Ht = u.Symbol,
		Dt = ue("JSON", "stringify"),
		Ft = C.f,
		Rt = q.f,
		Vt = $e.f,
		qt = d.f,
		Ut = ne("symbols"),
		Gt = ne("op-symbols"),
		Wt = ne("string-to-symbol-registry"),
		zt = ne("symbol-to-string-registry"),
		Qt = ne("wks"),
		Jt = u.QObject,
		Yt = !Jt || !Jt.prototype || !Jt.prototype.findChild,
		Xt =
			s &&
			c(function () {
				return (
					7 !=
					Qe(
						Rt({}, "a", {
							get: function () {
								return Rt(this, "a", { value: 7 }).a;
							}
						})
					).a
				);
			})
				? function (e, t, n) {
						var r = Ft(Bt, t);
						r && delete Bt[t], Rt(e, t, n), r && e !== Bt && Rt(Bt, t, r);
				  }
				: Rt,
		Kt = function (e, t) {
			var n = (Ut[e] = Qe(Ht.prototype));
			return (
				Nt(n, { type: "Symbol", tag: e, description: t }),
				s || (n.description = t),
				n
			);
		},
		Zt = ye
			? function (e) {
					return "symbol" == typeof e;
			  }
			: function (e) {
					return Object(e) instanceof Ht;
			  },
		$t = function (e, t, n) {
			e === Bt && $t(Gt, t, n), R(e);
			var r = O(t, !0);
			return (
				R(n),
				S(Ut, r)
					? (n.enumerable
							? (S(e, Et) && e[Et][r] && (e[Et][r] = !1),
							  (n = Qe(n, { enumerable: h(0, !1) })))
							: (S(e, Et) || Rt(e, Et, h(1, {})), (e[Et][r] = !0)),
					  Xt(e, r, n))
					: Rt(e, r, n)
			);
		},
		en = function (e, t) {
			R(e);
			var n = b(t),
				r = De(n).concat(on(n));
			return (
				Mt(r, function (t) {
					(s && !tn.call(n, t)) || $t(e, t, n[t]);
				}),
				e
			);
		},
		tn = function (e) {
			var t = O(e, !0),
				n = qt.call(this, t);
			return (
				!(this === Bt && S(Ut, t) && !S(Gt, t)) &&
				(!(n || !S(this, t) || !S(Ut, t) || (S(this, Et) && this[Et][t])) || n)
			);
		},
		nn = function (e, t) {
			var n = b(e),
				r = O(t, !0);
			if (n !== Bt || !S(Ut, r) || S(Gt, r)) {
				var o = Ft(n, r);
				return (
					!o || !S(Ut, r) || (S(n, Et) && n[Et][r]) || (o.enumerable = !0), o
				);
			}
		},
		rn = function (e) {
			var t = Vt(b(e)),
				n = [];
			return (
				Mt(t, function (e) {
					S(Ut, e) || S(Ne, e) || n.push(e);
				}),
				n
			);
		},
		on = function (e) {
			var t = e === Bt,
				n = Vt(t ? Gt : b(e)),
				r = [];
			return (
				Mt(n, function (e) {
					!S(Ut, e) || (t && !S(Bt, e)) || r.push(Ut[e]);
				}),
				r
			);
		};
	if (
		(me ||
			(tt(
				(Ht = function () {
					if (this instanceof Ht)
						throw TypeError("Symbol is not a constructor");
					var e =
							arguments.length && void 0 !== arguments[0]
								? String(arguments[0])
								: void 0,
						t = ae(e),
						n = function (e) {
							this === Bt && n.call(Gt, e),
								S(this, Et) && S(this[Et], t) && (this[Et][t] = !1),
								Xt(this, t, h(1, e));
						};
					return s && Yt && Xt(Bt, t, { configurable: !0, set: n }), Kt(t, e);
				}).prototype,
				"toString",
				function () {
					return Lt(this).tag;
				}
			),
			tt(Ht, "withoutSetter", function (e) {
				return Kt(ae(e), e);
			}),
			(d.f = tn),
			(q.f = $t),
			(C.f = nn),
			(Ye.f = $e.f = rn),
			(et.f = on),
			(nt.f = function (e) {
				return Kt(be(e), e);
			}),
			s &&
				Rt(Ht.prototype, "description", {
					configurable: !0,
					get: function () {
						return Lt(this).description;
					}
				})),
		z({ global: !0, wrap: !0, forced: !me, sham: !me }, { Symbol: Ht }),
		Mt(De(Qt), function (e) {
			ot(e);
		}),
		z(
			{ target: "Symbol", stat: !0, forced: !me },
			{
				for: function (e) {
					var t = String(e);
					if (S(Wt, t)) return Wt[t];
					var n = Ht(t);
					return (Wt[t] = n), (zt[n] = t), n;
				},
				keyFor: function (e) {
					if (!Zt(e)) throw TypeError(e + " is not a symbol");
					if (S(zt, e)) return zt[e];
				},
				useSetter: function () {
					Yt = !0;
				},
				useSimple: function () {
					Yt = !1;
				}
			}
		),
		z(
			{ target: "Object", stat: !0, forced: !me, sham: !s },
			{
				create: function (e, t) {
					return void 0 === t ? Qe(e) : en(Qe(e), t);
				},
				defineProperty: $t,
				defineProperties: en,
				getOwnPropertyDescriptor: nn
			}
		),
		z(
			{ target: "Object", stat: !0, forced: !me },
			{ getOwnPropertyNames: rn, getOwnPropertySymbols: on }
		),
		z(
			{
				target: "Object",
				stat: !0,
				forced: c(function () {
					et.f(1);
				})
			},
			{
				getOwnPropertySymbols: function (e) {
					return et.f(J(e));
				}
			}
		),
		Dt)
	) {
		var an =
			!me ||
			c(function () {
				var e = Ht();
				return (
					"[null]" != Dt([e]) || "{}" != Dt({ a: e }) || "{}" != Dt(Object(e))
				);
			});
		z(
			{ target: "JSON", stat: !0, forced: an },
			{
				stringify: function (e, t, n) {
					for (var r, o = [e], a = 1; arguments.length > a; )
						o.push(arguments[a++]);
					if (((r = t), (w(t) || void 0 !== e) && !Zt(e)))
						return (
							Q(t) ||
								(t = function (e, t) {
									if (
										("function" == typeof r && (t = r.call(this, e, t)), !Zt(t))
									)
										return t;
								}),
							(o[1] = t),
							Dt.apply(null, o)
						);
				}
			}
		);
	}
	Ht.prototype[At] || U(Ht.prototype, At, Ht.prototype.valueOf),
		dt(Ht, "Symbol"),
		(Ne[Et] = !0),
		ot("asyncIterator");
	var ln = Object.freeze({ __proto__: null });
	ot("hasInstance"),
		ot("isConcatSpreadable"),
		ot("iterator"),
		ot("match"),
		ot("matchAll"),
		ot("replace"),
		ot("search"),
		ot("species"),
		ot("split"),
		ot("toPrimitive"),
		ot("toStringTag"),
		ot("unscopables"),
		dt(u.JSON, "JSON", !0);
	var un = Object.freeze({ __proto__: null });
	o(Te), o(ln), o(un);
	var cn = D.Symbol;
	ot("asyncDispose"),
		ot("dispose"),
		ot("observable"),
		ot("patternMatch"),
		ot("replaceAll");
	var sn,
		pn,
		fn,
		dn = cn,
		hn = function (e) {
			return function (t, n) {
				var r,
					o,
					a = String(x(t)),
					l = K(n),
					i = a.length;
				return l < 0 || l >= i
					? e
						? ""
						: void 0
					: (r = a.charCodeAt(l)) < 55296 ||
					  r > 56319 ||
					  l + 1 === i ||
					  (o = a.charCodeAt(l + 1)) < 56320 ||
					  o > 57343
					? e
						? a.charAt(l)
						: r
					: e
					? a.slice(l, l + 2)
					: o - 56320 + ((r - 55296) << 10) + 65536;
			};
		},
		mn = { codeAt: hn(!1), charAt: hn(!0) },
		yn = !c(function () {
			function e() {}
			return (
				(e.prototype.constructor = null),
				Object.getPrototypeOf(new e()) !== e.prototype
			);
		}),
		vn = qe("IE_PROTO"),
		gn = Object.prototype,
		xn = yn
			? Object.getPrototypeOf
			: function (e) {
					return (
						(e = J(e)),
						S(e, vn)
							? e[vn]
							: "function" == typeof e.constructor && e instanceof e.constructor
							? e.constructor.prototype
							: e instanceof Object
							? gn
							: null
					);
			  },
		bn = be("iterator"),
		wn = !1;
	[].keys &&
		("next" in (fn = [].keys())
			? (pn = xn(xn(fn))) !== Object.prototype && (sn = pn)
			: (wn = !0));
	var On =
		null == sn ||
		c(function () {
			var e = {};
			return sn[bn].call(e) !== e;
		});
	On && (sn = {}),
		On &&
			!S(sn, bn) &&
			U(sn, bn, function () {
				return this;
			});
	var Pn = { IteratorPrototype: sn, BUGGY_SAFARI_ITERATORS: wn },
		Sn = Pn.IteratorPrototype,
		_n =
			(Object.setPrototypeOf ||
				("__proto__" in {} &&
					(function () {
						var e,
							t = !1,
							n = {};
						try {
							(e = Object.getOwnPropertyDescriptor(
								Object.prototype,
								"__proto__"
							).set).call(n, []),
								(t = n instanceof Array);
						} catch (e) {}
					})()),
			Pn.IteratorPrototype),
		jn = Pn.BUGGY_SAFARI_ITERATORS,
		kn = be("iterator"),
		In = function (e, t, n, r, o, a, l) {
			!(function (e, t, n) {
				var r = t + " Iterator";
				(e.prototype = Qe(Sn, { next: h(1, n) })), dt(e, r, !1, !0);
			})(n, t, r);
			var i,
				u,
				c,
				s = function (e) {
					if (e === o && y) return y;
					if (!jn && e in d) return d[e];
					switch (e) {
						case "keys":
						case "values":
						case "entries":
							return function () {
								return new n(this, e);
							};
					}
					return function () {
						return new n(this);
					};
				},
				p = t + " Iterator",
				f = !1,
				d = e.prototype,
				m = d[kn] || d["@@iterator"] || (o && d[o]),
				y = (!jn && m) || s(o),
				v = ("Array" == t && d.entries) || m;
			if (
				(v &&
					((i = xn(v.call(new e()))),
					_n !== Object.prototype && i.next && dt(i, p, !0, !0)),
				"values" == o &&
					m &&
					"values" !== m.name &&
					((f = !0),
					(y = function () {
						return m.call(this);
					})),
				l && d[kn] !== y && U(d, kn, y),
				o)
			)
				if (
					((u = {
						values: s("values"),
						keys: a ? y : s("keys"),
						entries: s("entries")
					}),
					l)
				)
					for (c in u) (jn || f || !(c in d)) && tt(d, c, u[c]);
				else z({ target: t, proto: !0, forced: jn || f }, u);
			return u;
		},
		Tn = mn.charAt,
		Cn = kt.set,
		Mn = kt.getterFor("String Iterator");
	In(
		String,
		"String",
		function (e) {
			Cn(this, { type: "String Iterator", string: String(e), index: 0 });
		},
		function () {
			var e,
				t = Mn(this),
				n = t.string,
				r = t.index;
			return r >= n.length
				? { value: void 0, done: !0 }
				: ((e = Tn(n, r)), (t.index += e.length), { value: e, done: !1 });
		}
	);
	var En = kt.set,
		An = kt.getterFor("Array Iterator"),
		Nn =
			(In(
				Array,
				"Array",
				function (e, t) {
					En(this, { type: "Array Iterator", target: b(e), index: 0, kind: t });
				},
				function () {
					var e = An(this),
						t = e.target,
						n = e.kind,
						r = e.index++;
					return !t || r >= t.length
						? ((e.target = void 0), { value: void 0, done: !0 })
						: "keys" == n
						? { value: r, done: !1 }
						: "values" == n
						? { value: t[r], done: !1 }
						: { value: [r, t[r]], done: !1 };
				},
				"values"
			),
			be("toStringTag"));
	for (var Ln in {
		CSSRuleList: 0,
		CSSStyleDeclaration: 0,
		CSSValueList: 0,
		ClientRectList: 0,
		DOMRectList: 0,
		DOMStringList: 0,
		DOMTokenList: 1,
		DataTransferItemList: 0,
		FileList: 0,
		HTMLAllCollection: 0,
		HTMLCollection: 0,
		HTMLFormElement: 0,
		HTMLSelectElement: 0,
		MediaList: 0,
		MimeTypeArray: 0,
		NamedNodeMap: 0,
		NodeList: 1,
		PaintRequestList: 0,
		Plugin: 0,
		PluginArray: 0,
		SVGLengthList: 0,
		SVGNumberList: 0,
		SVGPathSegList: 0,
		SVGPointList: 0,
		SVGStringList: 0,
		SVGTransformList: 0,
		SourceBufferList: 0,
		StyleSheetList: 0,
		TextTrackCueList: 0,
		TextTrackList: 0,
		TouchList: 0
	}) {
		var Bn = u[Ln],
			Hn = Bn && Bn.prototype;
		Hn && ct(Hn) !== Nn && U(Hn, Nn, Ln);
	}
	var Dn = nt.f("iterator"),
		Fn = n(
			r(function (e) {
				function t(n) {
					return (
						"function" == typeof dn && "symbol" == typeof Dn
							? ((e.exports = t = function (e) {
									return typeof e;
							  }),
							  (e.exports.default = e.exports),
							  (e.exports.__esModule = !0))
							: ((e.exports = t = function (e) {
									return e &&
										"function" == typeof dn &&
										e.constructor === dn &&
										e !== dn.prototype
										? "symbol"
										: typeof e;
							  }),
							  (e.exports.default = e.exports),
							  (e.exports.__esModule = !0)),
						t(n)
					);
				}
				(e.exports = t),
					(e.exports.default = e.exports),
					(e.exports.__esModule = !0);
			})
		),
		Rn = function (e, t) {
			var n = [][e];
			return (
				!!n &&
				c(function () {
					n.call(
						null,
						t ||
							function () {
								throw 1;
							},
						1
					);
				})
			);
		},
		Vn = Ae.indexOf,
		qn = [].indexOf,
		Un = !!qn && 1 / [1].indexOf(1, -0) < 0,
		Gn = Rn("indexOf");
	z(
		{ target: "Array", proto: !0, forced: Un || !Gn },
		{
			indexOf: function (e) {
				return Un
					? qn.apply(this, arguments) || 0
					: Vn(this, e, arguments.length > 1 ? arguments[1] : void 0);
			}
		}
	);
	var Wn = function (e) {
			return D[e + "Prototype"];
		},
		zn = Wn("Array").indexOf,
		Qn = Array.prototype,
		Jn = function (e) {
			var t = e.indexOf;
			return e === Qn || (e instanceof Array && t === Qn.indexOf) ? zn : t;
		},
		Yn = Wn("Array").concat,
		Xn = Array.prototype,
		Kn = function (e) {
			var t = e.concat;
			return e === Xn || (e instanceof Array && t === Xn.concat) ? Yn : t;
		},
		Zn =
			"\t\n\v\f\r Â áš€â€€â€â€‚â€ƒâ€„â€…â€†â€‡â€ˆâ€‰â€Šâ€¯âŸã€€\u2028\u2029\ufeff",
		$n = "[" + Zn + "]",
		er = RegExp("^" + $n + $n + "*"),
		tr = RegExp($n + $n + "*$"),
		nr = function (e) {
			return function (t) {
				var n = String(x(t));
				return (
					1 & e && (n = n.replace(er, "")), 2 & e && (n = n.replace(tr, "")), n
				);
			};
		},
		rr = { start: nr(1), end: nr(2), trim: nr(3) }.trim,
		or = u.parseInt,
		ar = /^[+-]?0[Xx]/,
		lr =
			8 !== or(Zn + "08") || 22 !== or(Zn + "0x16")
				? function (e, t) {
						var n = rr(String(e));
						return or(n, t >>> 0 || (ar.test(n) ? 16 : 10));
				  }
				: or;
	z({ global: !0, forced: parseInt != lr }, { parseInt: lr });
	var ir = D.parseInt,
		ur = Ct.forEach,
		cr = Rn("forEach")
			? [].forEach
			: function (e) {
					return ur(this, e, arguments.length > 1 ? arguments[1] : void 0);
			  };
	z({ target: "Array", proto: !0, forced: [].forEach != cr }, { forEach: cr });
	var sr = Wn("Array").forEach,
		pr = Array.prototype,
		fr = { DOMTokenList: !0, NodeList: !0 },
		dr = function (e) {
			var t = e.forEach;
			return e === pr ||
				(e instanceof Array && t === pr.forEach) ||
				fr.hasOwnProperty(ct(e))
				? sr
				: t;
		},
		hr = Wn("Array").keys,
		mr = Array.prototype,
		yr = { DOMTokenList: !0, NodeList: !0 },
		vr = function (e) {
			var t = e.keys;
			return e === mr ||
				(e instanceof Array && t === mr.keys) ||
				yr.hasOwnProperty(ct(e))
				? hr
				: t;
		};
	z(
		{ target: "Object", stat: !0, forced: !s, sham: !s },
		{ defineProperty: q.f }
	);
	var gr = r(function (e) {
		var t = D.Object,
			n = (e.exports = function (e, n, r) {
				return t.defineProperty(e, n, r);
			});
		t.defineProperty.sham && (n.sham = !0);
	});
	z({ target: "Array", stat: !0 }, { isArray: Q });
	var xr = D.Array.isArray,
		br = r(function (e, t) {
			/**!

	   @license
	   handlebars v4.7.7

	  Copyright (C) 2011-2019 by Yehuda Katz

	  Permission is hereby granted, free of charge, to any person obtaining a copy
	  of this software and associated documentation files (the "Software"), to deal
	  in the Software without restriction, including without limitation the rights
	  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	  copies of the Software, and to permit persons to whom the Software is
	  furnished to do so, subject to the following conditions:

	  The above copyright notice and this permission notice shall be included in
	  all copies or substantial portions of the Software.

	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	  THE SOFTWARE.

	  */
			e.exports = (function (e) {
				function t(r) {
					if (n[r]) return n[r].exports;
					var o = (n[r] = { exports: {}, id: r, loaded: !1 });
					return (
						e[r].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports
					);
				}
				var n = {};
				return (t.m = e), (t.c = n), (t.p = ""), t(0);
			})([
				function (e, t, n) {
					function r() {
						var e = new l.HandlebarsEnvironment();
						return (
							c.extend(e, l),
							(e.SafeString = i.default),
							(e.Exception = u.default),
							(e.Utils = c),
							(e.escapeExpression = c.escapeExpression),
							(e.VM = s),
							(e.template = function (t) {
								return s.template(t, e);
							}),
							e
						);
					}
					var o = n(1).default,
						a = n(2).default;
					t.__esModule = !0;
					var l = o(n(3)),
						i = a(n(36)),
						u = a(n(5)),
						c = o(n(4)),
						s = o(n(37)),
						p = a(n(43)),
						f = r();
					(f.create = r),
						p.default(f),
						(f.default = f),
						(t.default = f),
						(e.exports = t.default);
				},
				function (e, t) {
					(t.default = function (e) {
						if (e && e.__esModule) return e;
						var t = {};
						if (null != e)
							for (var n in e)
								Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
						return (t.default = e), t;
					}),
						(t.__esModule = !0);
				},
				function (e, t) {
					(t.default = function (e) {
						return e && e.__esModule ? e : { default: e };
					}),
						(t.__esModule = !0);
				},
				function (e, t, n) {
					function r(e, t, n) {
						(this.helpers = e || {}),
							(this.partials = t || {}),
							(this.decorators = n || {}),
							i.registerDefaultHelpers(this),
							u.registerDefaultDecorators(this);
					}
					var o = n(2).default;
					(t.__esModule = !0), (t.HandlebarsEnvironment = r);
					var a = n(4),
						l = o(n(5)),
						i = n(9),
						u = n(29),
						c = o(n(31)),
						s = n(32);
					(t.VERSION = "4.7.7"),
						(t.COMPILER_REVISION = 8),
						(t.LAST_COMPATIBLE_COMPILER_REVISION = 7),
						(t.REVISION_CHANGES = {
							1: "<= 1.0.rc.2",
							2: "== 1.0.0-rc.3",
							3: "== 1.0.0-rc.4",
							4: "== 1.x.x",
							5: "== 2.0.0-alpha.x",
							6: ">= 2.0.0-beta.1",
							7: ">= 4.0.0 <4.3.0",
							8: ">= 4.3.0"
						});
					var p = "[object Object]";
					r.prototype = {
						constructor: r,
						logger: c.default,
						log: c.default.log,
						registerHelper: function (e, t) {
							if (a.toString.call(e) === p) {
								if (t)
									throw new l.default(
										"Arg not supported with multiple helpers"
									);
								a.extend(this.helpers, e);
							} else this.helpers[e] = t;
						},
						unregisterHelper: function (e) {
							delete this.helpers[e];
						},
						registerPartial: function (e, t) {
							if (a.toString.call(e) === p) a.extend(this.partials, e);
							else {
								if (void 0 === t)
									throw new l.default(
										'Attempting to register a partial called "' +
											e +
											'" as undefined'
									);
								this.partials[e] = t;
							}
						},
						unregisterPartial: function (e) {
							delete this.partials[e];
						},
						registerDecorator: function (e, t) {
							if (a.toString.call(e) === p) {
								if (t)
									throw new l.default(
										"Arg not supported with multiple decorators"
									);
								a.extend(this.decorators, e);
							} else this.decorators[e] = t;
						},
						unregisterDecorator: function (e) {
							delete this.decorators[e];
						},
						resetLoggedPropertyAccesses: function () {
							s.resetLoggedProperties();
						}
					};
					var f = c.default.log;
					(t.log = f), (t.createFrame = a.createFrame), (t.logger = c.default);
				},
				function (e, t) {
					function n(e) {
						return o[e];
					}
					function r(e) {
						for (var t = 1; t < arguments.length; t++)
							for (var n in arguments[t])
								Object.prototype.hasOwnProperty.call(arguments[t], n) &&
									(e[n] = arguments[t][n]);
						return e;
					}
					(t.__esModule = !0),
						(t.extend = r),
						(t.indexOf = function (e, t) {
							for (var n = 0, r = e.length; n < r; n++)
								if (e[n] === t) return n;
							return -1;
						}),
						(t.escapeExpression = function (e) {
							if ("string" != typeof e) {
								if (e && e.toHTML) return e.toHTML();
								if (null == e) return "";
								if (!e) return e + "";
								e = "" + e;
							}
							return l.test(e) ? e.replace(a, n) : e;
						}),
						(t.isEmpty = function (e) {
							return (!e && 0 !== e) || !(!c(e) || 0 !== e.length);
						}),
						(t.createFrame = function (e) {
							var t = r({}, e);
							return (t._parent = e), t;
						}),
						(t.blockParams = function (e, t) {
							return (e.path = t), e;
						}),
						(t.appendContextPath = function (e, t) {
							return (e ? e + "." : "") + t;
						});
					var o = {
							"&": "&amp;",
							"<": "&lt;",
							">": "&gt;",
							'"': "&quot;",
							"'": "&#x27;",
							"`": "&#x60;",
							"=": "&#x3D;"
						},
						a = /[&<>"'`=]/g,
						l = /[&<>"'`=]/,
						i = Object.prototype.toString;
					t.toString = i;
					var u = function (e) {
						return "function" == typeof e;
					};
					u(/x/) &&
						(t.isFunction = u = function (e) {
							return (
								"function" == typeof e && "[object Function]" === i.call(e)
							);
						}),
						(t.isFunction = u);
					var c =
						xr ||
						function (e) {
							return (
								!(!e || "object" != Fn(e)) && "[object Array]" === i.call(e)
							);
						};
					t.isArray = c;
				},
				function (e, t, n) {
					function r(e, t) {
						var n = t && t.loc,
							l = void 0,
							i = void 0,
							u = void 0,
							c = void 0;
						n &&
							((l = n.start.line),
							(i = n.end.line),
							(u = n.start.column),
							(c = n.end.column),
							(e += " - " + l + ":" + u));
						for (
							var s = Error.prototype.constructor.call(this, e), p = 0;
							p < a.length;
							p++
						)
							this[a[p]] = s[a[p]];
						Error.captureStackTrace && Error.captureStackTrace(this, r);
						try {
							n &&
								((this.lineNumber = l),
								(this.endLineNumber = i),
								o
									? (gr(this, "column", { value: u, enumerable: !0 }),
									  gr(this, "endColumn", { value: c, enumerable: !0 }))
									: ((this.column = u), (this.endColumn = c)));
						} catch (e) {}
					}
					var o = n(6).default;
					t.__esModule = !0;
					var a = [
						"description",
						"fileName",
						"lineNumber",
						"endLineNumber",
						"message",
						"name",
						"number",
						"stack"
					];
					(r.prototype = new Error()), (t.default = r), (e.exports = t.default);
				},
				function (e, t, n) {
					e.exports = { default: n(7), __esModule: !0 };
				},
				function (e, t, n) {
					var r = n(8);
					e.exports = function (e, t, n) {
						return r.setDesc(e, t, n);
					};
				},
				function (e, t) {
					var n = Object;
					e.exports = {
						create: n.create,
						getProto: n.getPrototypeOf,
						isEnum: {}.propertyIsEnumerable,
						getDesc: n.getOwnPropertyDescriptor,
						setDesc: n.defineProperty,
						setDescs: n.defineProperties,
						getKeys: vr(n),
						getNames: n.getOwnPropertyNames,
						getSymbols: n.getOwnPropertySymbols,
						each: dr([])
					};
				},
				function (e, t, n) {
					var r = n(2).default;
					(t.__esModule = !0),
						(t.registerDefaultHelpers = function (e) {
							o.default(e),
								a.default(e),
								l.default(e),
								i.default(e),
								u.default(e),
								c.default(e),
								s.default(e);
						}),
						(t.moveHelperToHooks = function (e, t, n) {
							e.helpers[t] &&
								((e.hooks[t] = e.helpers[t]), n || delete e.helpers[t]);
						});
					var o = r(n(10)),
						a = r(n(11)),
						l = r(n(24)),
						i = r(n(25)),
						u = r(n(26)),
						c = r(n(27)),
						s = r(n(28));
				},
				function (e, t, n) {
					t.__esModule = !0;
					var r = n(4);
					(t.default = function (e) {
						e.registerHelper("blockHelperMissing", function (t, n) {
							var o = n.inverse,
								a = n.fn;
							if (!0 === t) return a(this);
							if (!1 === t || null == t) return o(this);
							if (r.isArray(t))
								return t.length > 0
									? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n))
									: o(this);
							if (n.data && n.ids) {
								var l = r.createFrame(n.data);
								(l.contextPath = r.appendContextPath(
									n.data.contextPath,
									n.name
								)),
									(n = { data: l });
							}
							return a(t, n);
						});
					}),
						(e.exports = t.default);
				},
				function (e, t, n) {
					(function (r) {
						var o = n(12).default,
							a = n(2).default;
						t.__esModule = !0;
						var l = n(4),
							i = a(n(5));
						(t.default = function (e) {
							e.registerHelper("each", function (e, t) {
								function n(t, n, r) {
									p &&
										((p.key = t),
										(p.index = n),
										(p.first = 0 === n),
										(p.last = !!r),
										f && (p.contextPath = f + t)),
										(s += a(e[t], {
											data: p,
											blockParams: l.blockParams([e[t], t], [f + t, null])
										}));
								}
								if (!t) throw new i.default("Must pass iterator to #each");
								var a = t.fn,
									u = t.inverse,
									c = 0,
									s = "",
									p = void 0,
									f = void 0;
								if (
									(t.data &&
										t.ids &&
										(f =
											l.appendContextPath(t.data.contextPath, t.ids[0]) + "."),
									l.isFunction(e) && (e = e.call(this)),
									t.data && (p = l.createFrame(t.data)),
									e && "object" == Fn(e))
								)
									if (l.isArray(e))
										for (var d = e.length; c < d; c++)
											c in e && n(c, c, c === e.length - 1);
									else if (r.Symbol && e[r.Symbol.iterator]) {
										for (
											var h = [], m = e[r.Symbol.iterator](), y = m.next();
											!y.done;
											y = m.next()
										)
											h.push(y.value);
										for (d = (e = h).length; c < d; c++)
											n(c, c, c === e.length - 1);
									} else
										!(function () {
											var t,
												r = void 0;
											dr((t = o(e))).call(t, function (e) {
												void 0 !== r && n(r, c - 1), (r = e), c++;
											}),
												void 0 !== r && n(r, c - 1, !0);
										})();
								return 0 === c && (s = u(this)), s;
							});
						}),
							(e.exports = t.default);
					}.call(
						t,
						(function () {
							return this;
						})()
					));
				},
				function (e, t, n) {
					e.exports = { default: n(13), __esModule: !0 };
				},
				function (e, t, n) {
					n(14), (e.exports = vr(n(20).Object));
				},
				function (e, t, n) {
					var r = n(15);
					n(17)("keys", function (e) {
						return function (t) {
							return e(r(t));
						};
					});
				},
				function (e, t, n) {
					var r = n(16);
					e.exports = function (e) {
						return Object(r(e));
					};
				},
				function (e, t) {
					e.exports = function (e) {
						if (null == e) throw TypeError("Can't call method on  " + e);
						return e;
					};
				},
				function (e, t, n) {
					var r = n(18),
						o = n(20),
						a = n(23);
					e.exports = function (e, t) {
						var n = (o.Object || {})[e] || Object[e],
							l = {};
						(l[e] = t(n)),
							r(
								r.S +
									r.F *
										a(function () {
											n(1);
										}),
								"Object",
								l
							);
					};
				},
				function (e, t, n) {
					var r = n(19),
						o = n(20),
						a = n(21),
						l = "prototype",
						i = function e(t, n, i) {
							var u,
								c,
								s,
								p = t & e.F,
								f = t & e.G,
								d = t & e.S,
								h = t & e.P,
								m = t & e.B,
								y = t & e.W,
								v = f ? o : o[n] || (o[n] = {}),
								g = f ? r : d ? r[n] : (r[n] || {})[l];
							for (u in (f && (i = n), i))
								((c = !p && g && u in g) && u in v) ||
									((s = c ? g[u] : i[u]),
									(v[u] =
										f && "function" != typeof g[u]
											? i[u]
											: m && c
											? a(s, r)
											: y && g[u] == s
											? (function (e) {
													var t = function (t) {
														return this instanceof e ? new e(t) : e(t);
													};
													return (t[l] = e[l]), t;
											  })(s)
											: h && "function" == typeof s
											? a(Function.call, s)
											: s),
									h && ((v[l] || (v[l] = {}))[u] = s));
						};
					(i.F = 1),
						(i.G = 2),
						(i.S = 4),
						(i.P = 8),
						(i.B = 16),
						(i.W = 32),
						(e.exports = i);
				},
				function (e, t) {
					var n = (e.exports =
						"undefined" != typeof window && window.Math == Math
							? window
							: "undefined" != typeof self && self.Math == Math
							? self
							: Function("return this")());
					"number" == typeof __g && (__g = n);
				},
				function (e, t) {
					var n = (e.exports = { version: "1.2.6" });
					"number" == typeof __e && (__e = n);
				},
				function (e, t, n) {
					var r = n(22);
					e.exports = function (e, t, n) {
						if ((r(e), void 0 === t)) return e;
						switch (n) {
							case 1:
								return function (n) {
									return e.call(t, n);
								};
							case 2:
								return function (n, r) {
									return e.call(t, n, r);
								};
							case 3:
								return function (n, r, o) {
									return e.call(t, n, r, o);
								};
						}
						return function () {
							return e.apply(t, arguments);
						};
					};
				},
				function (e, t) {
					e.exports = function (e) {
						if ("function" != typeof e)
							throw TypeError(e + " is not a function!");
						return e;
					};
				},
				function (e, t) {
					e.exports = function (e) {
						try {
							return !!e();
						} catch (e) {
							return !0;
						}
					};
				},
				function (e, t, n) {
					var r = n(2).default;
					t.__esModule = !0;
					var o = r(n(5));
					(t.default = function (e) {
						e.registerHelper("helperMissing", function () {
							if (1 !== arguments.length)
								throw new o.default(
									'Missing helper: "' +
										arguments[arguments.length - 1].name +
										'"'
								);
						});
					}),
						(e.exports = t.default);
				},
				function (e, t, n) {
					var r = n(2).default;
					t.__esModule = !0;
					var o = n(4),
						a = r(n(5));
					(t.default = function (e) {
						e.registerHelper("if", function (e, t) {
							if (2 != arguments.length)
								throw new a.default("#if requires exactly one argument");
							return (
								o.isFunction(e) && (e = e.call(this)),
								(!t.hash.includeZero && !e) || o.isEmpty(e)
									? t.inverse(this)
									: t.fn(this)
							);
						}),
							e.registerHelper("unless", function (t, n) {
								if (2 != arguments.length)
									throw new a.default("#unless requires exactly one argument");
								return e.helpers.if.call(this, t, {
									fn: n.inverse,
									inverse: n.fn,
									hash: n.hash
								});
							});
					}),
						(e.exports = t.default);
				},
				function (e, t) {
					(t.__esModule = !0),
						(t.default = function (e) {
							e.registerHelper("log", function () {
								for (
									var t = [void 0], n = arguments[arguments.length - 1], r = 0;
									r < arguments.length - 1;
									r++
								)
									t.push(arguments[r]);
								var o = 1;
								null != n.hash.level
									? (o = n.hash.level)
									: n.data && null != n.data.level && (o = n.data.level),
									(t[0] = o),
									e.log.apply(e, t);
							});
						}),
						(e.exports = t.default);
				},
				function (e, t) {
					(t.__esModule = !0),
						(t.default = function (e) {
							e.registerHelper("lookup", function (e, t, n) {
								return e ? n.lookupProperty(e, t) : e;
							});
						}),
						(e.exports = t.default);
				},
				function (e, t, n) {
					var r = n(2).default;
					t.__esModule = !0;
					var o = n(4),
						a = r(n(5));
					(t.default = function (e) {
						e.registerHelper("with", function (e, t) {
							if (2 != arguments.length)
								throw new a.default("#with requires exactly one argument");
							o.isFunction(e) && (e = e.call(this));
							var n = t.fn;
							if (o.isEmpty(e)) return t.inverse(this);
							var r = t.data;
							return (
								t.data &&
									t.ids &&
									((r = o.createFrame(
										t.data
									)).contextPath = o.appendContextPath(
										t.data.contextPath,
										t.ids[0]
									)),
								n(e, {
									data: r,
									blockParams: o.blockParams([e], [r && r.contextPath])
								})
							);
						});
					}),
						(e.exports = t.default);
				},
				function (e, t, n) {
					var r = n(2).default;
					(t.__esModule = !0),
						(t.registerDefaultDecorators = function (e) {
							o.default(e);
						});
					var o = r(n(30));
				},
				function (e, t, n) {
					t.__esModule = !0;
					var r = n(4);
					(t.default = function (e) {
						e.registerDecorator("inline", function (e, t, n, o) {
							var a = e;
							return (
								t.partials ||
									((t.partials = {}),
									(a = function (o, a) {
										var l = n.partials;
										n.partials = r.extend({}, l, t.partials);
										var i = e(o, a);
										return (n.partials = l), i;
									})),
								(t.partials[o.args[0]] = o.fn),
								a
							);
						});
					}),
						(e.exports = t.default);
				},
				function (e, t, n) {
					t.__esModule = !0;
					var r = n(4),
						o = {
							methodMap: ["debug", "info", "warn", "error"],
							level: "info",
							lookupLevel: function (e) {
								if ("string" == typeof e) {
									var t = Jn(r).call(r, o.methodMap, e.toLowerCase());
									e = t >= 0 ? t : ir(e, 10);
								}
								return e;
							},
							log: function (e) {
								if (
									((e = o.lookupLevel(e)),
									"undefined" != typeof console && o.lookupLevel(o.level) <= e)
								) {
									var t = o.methodMap[e];
									console[t] || (t = "log");
									for (
										var n = arguments.length,
											r = Array(n > 1 ? n - 1 : 0),
											a = 1;
										a < n;
										a++
									)
										r[a - 1] = arguments[a];
									console[t].apply(console, r);
								}
							}
						};
					(t.default = o), (e.exports = t.default);
				},
				function (e, t, n) {
					function r(e, t) {
						return void 0 !== e.whitelist[t]
							? !0 === e.whitelist[t]
							: void 0 !== e.defaultValue
							? e.defaultValue
							: ((function (e) {
									!0 !== c[e] &&
										((c[e] = !0),
										u.log(
											"error",
											'Handlebars: Access has been denied to resolve the property "' +
												e +
												'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
										));
							  })(t),
							  !1);
					}
					var o = n(33).default,
						a = n(12).default,
						l = n(1).default;
					(t.__esModule = !0),
						(t.createProtoAccessControl = function (e) {
							var t = o(null);
							(t.constructor = !1),
								(t.__defineGetter__ = !1),
								(t.__defineSetter__ = !1),
								(t.__lookupGetter__ = !1);
							var n = o(null);
							return (
								(n.__proto__ = !1),
								{
									properties: {
										whitelist: i.createNewLookupObject(
											n,
											e.allowedProtoProperties
										),
										defaultValue: e.allowProtoPropertiesByDefault
									},
									methods: {
										whitelist: i.createNewLookupObject(
											t,
											e.allowedProtoMethods
										),
										defaultValue: e.allowProtoMethodsByDefault
									}
								}
							);
						}),
						(t.resultIsAllowed = function (e, t, n) {
							return r("function" == typeof e ? t.methods : t.properties, n);
						}),
						(t.resetLoggedProperties = function () {
							var e;
							dr((e = a(c))).call(e, function (e) {
								delete c[e];
							});
						});
					var i = n(35),
						u = l(n(31)),
						c = o(null);
				},
				function (e, t, n) {
					e.exports = { default: n(34), __esModule: !0 };
				},
				function (e, t, n) {
					var r = n(8);
					e.exports = function (e, t) {
						return r.create(e, t);
					};
				},
				function (e, t, n) {
					var r = n(33).default;
					(t.__esModule = !0),
						(t.createNewLookupObject = function () {
							for (var e, t = arguments.length, n = Array(t), a = 0; a < t; a++)
								n[a] = arguments[a];
							return o.extend.apply(void 0, Kn((e = [r(null)])).call(e, n));
						});
					var o = n(4);
				},
				function (e, t) {
					function n(e) {
						this.string = e;
					}
					(t.__esModule = !0),
						(n.prototype.toString = n.prototype.toHTML = function () {
							return "" + this.string;
						}),
						(t.default = n),
						(e.exports = t.default);
				},
				function (e, t, n) {
					function r(e, t, n, r, o, a, i) {
						function u(t) {
							var o,
								l,
								u =
									arguments.length <= 1 || void 0 === arguments[1]
										? {}
										: arguments[1],
								c = i;
							return (
								!i ||
									t == i[0] ||
									(t === e.nullContext && null === i[0]) ||
									(c = Kn((o = [t])).call(o, i)),
								n(
									e,
									t,
									e.helpers,
									e.partials,
									u.data || r,
									a && Kn((l = [u.blockParams])).call(l, a),
									c
								)
							);
						}
						return (
							((u = l(n, u, e, i, r, a)).program = t),
							(u.depth = i ? i.length : 0),
							(u.blockParams = o || 0),
							u
						);
					}
					function o() {
						return "";
					}
					function a(e, t) {
						return (
							(t && "root" in t) || ((t = t ? d.createFrame(t) : {}).root = e),
							t
						);
					}
					function l(e, t, n, r, o, a) {
						if (e.decorator) {
							var l = {};
							(t = e.decorator(t, l, n, r && r[0], o, a, r)), p.extend(t, l);
						}
						return t;
					}
					var i = n(38).default,
						u = n(12).default,
						c = n(1).default,
						s = n(2).default;
					(t.__esModule = !0),
						(t.checkRevision = function (e) {
							var t = (e && e[0]) || 1,
								n = d.COMPILER_REVISION;
							if (
								!(
									t >= d.LAST_COMPATIBLE_COMPILER_REVISION &&
									t <= d.COMPILER_REVISION
								)
							) {
								if (t < d.LAST_COMPATIBLE_COMPILER_REVISION) {
									var r = d.REVISION_CHANGES[n],
										o = d.REVISION_CHANGES[t];
									throw new f.default(
										"Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
											r +
											") or downgrade your runtime to an older version (" +
											o +
											")."
									);
								}
								throw new f.default(
									"Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
										e[1] +
										")."
								);
							}
						}),
						(t.template = function (e, t) {
							function n(t) {
								var r;
								function o(t) {
									return "" + e.main(c, t, c.helpers, c.partials, u, p, s);
								}
								var i =
										arguments.length <= 1 || void 0 === arguments[1]
											? {}
											: arguments[1],
									u = i.data;
								n._setup(i), !i.partial && e.useData && (u = a(t, u));
								var s = void 0,
									p = e.useBlockParams ? [] : void 0;
								return (
									e.useDepths &&
										(s = i.depths
											? t != i.depths[0]
												? Kn((r = [t])).call(r, i.depths)
												: i.depths
											: [t]),
									(o = l(e.main, o, c, i.depths || [], u, p))(t, i)
								);
							}
							if (!t) throw new f.default("No environment passed to template");
							if (!e || !e.main)
								throw new f.default("Unknown template object: " + Fn(e));
							(e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
							var o = e.compiler && 7 === e.compiler[0],
								c = {
									strict: function (e, t, n) {
										if (!e || !(t in e))
											throw new f.default('"' + t + '" not defined in ' + e, {
												loc: n
											});
										return c.lookupProperty(e, t);
									},
									lookupProperty: function (e, t) {
										var n = e[t];
										return null == n ||
											Object.prototype.hasOwnProperty.call(e, t) ||
											y.resultIsAllowed(n, c.protoAccessControl, t)
											? n
											: void 0;
									},
									lookup: function (e, t) {
										for (var n = e.length, r = 0; r < n; r++)
											if (null != (e[r] && c.lookupProperty(e[r], t)))
												return e[r][t];
									},
									lambda: function (e, t) {
										return "function" == typeof e ? e.call(t) : e;
									},
									escapeExpression: p.escapeExpression,
									invokePartial: function (n, r, o) {
										o.hash &&
											((r = p.extend({}, r, o.hash)), o.ids && (o.ids[0] = !0)),
											(n = t.VM.resolvePartial.call(this, n, r, o));
										var a = p.extend({}, o, {
												hooks: this.hooks,
												protoAccessControl: this.protoAccessControl
											}),
											l = t.VM.invokePartial.call(this, n, r, a);
										if (
											(null == l &&
												t.compile &&
												((o.partials[o.name] = t.compile(
													n,
													e.compilerOptions,
													t
												)),
												(l = o.partials[o.name](r, a))),
											null != l)
										) {
											if (o.indent) {
												for (
													var i = l.split("\n"), u = 0, c = i.length;
													u < c && (i[u] || u + 1 !== c);
													u++
												)
													i[u] = o.indent + i[u];
												l = i.join("\n");
											}
											return l;
										}
										throw new f.default(
											"The partial " +
												o.name +
												" could not be compiled when running in runtime-only mode"
										);
									},
									fn: function (t) {
										var n = e[t];
										return (n.decorator = e[t + "_d"]), n;
									},
									programs: [],
									program: function (e, t, n, o, a) {
										var l = this.programs[e],
											i = this.fn(e);
										return (
											t || a || o || n
												? (l = r(this, e, i, t, n, o, a))
												: l || (l = this.programs[e] = r(this, e, i)),
											l
										);
									},
									data: function (e, t) {
										for (; e && t--; ) e = e._parent;
										return e;
									},
									mergeIfNeeded: function (e, t) {
										var n = e || t;
										return e && t && e !== t && (n = p.extend({}, t, e)), n;
									},
									nullContext: i({}),
									noop: t.VM.noop,
									compilerInfo: e.compiler
								};
							return (
								(n.isTop = !0),
								(n._setup = function (n) {
									if (n.partial)
										(c.protoAccessControl = n.protoAccessControl),
											(c.helpers = n.helpers),
											(c.partials = n.partials),
											(c.decorators = n.decorators),
											(c.hooks = n.hooks);
									else {
										var r = p.extend({}, t.helpers, n.helpers);
										(function (e, t) {
											var n;
											dr((n = u(e))).call(n, function (n) {
												var r = e[n];
												e[n] = (function (e, t) {
													var n = t.lookupProperty;
													return m.wrapHelper(e, function (e) {
														return p.extend({ lookupProperty: n }, e);
													});
												})(r, t);
											});
										})(r, c),
											(c.helpers = r),
											e.usePartial &&
												(c.partials = c.mergeIfNeeded(n.partials, t.partials)),
											(e.usePartial || e.useDecorators) &&
												(c.decorators = p.extend(
													{},
													t.decorators,
													n.decorators
												)),
											(c.hooks = {}),
											(c.protoAccessControl = y.createProtoAccessControl(n));
										var a = n.allowCallsToHelperMissing || o;
										h.moveHelperToHooks(c, "helperMissing", a),
											h.moveHelperToHooks(c, "blockHelperMissing", a);
									}
								}),
								(n._child = function (t, n, o, a) {
									if (e.useBlockParams && !o)
										throw new f.default("must pass block params");
									if (e.useDepths && !a)
										throw new f.default("must pass parent depths");
									return r(c, t, e[t], n, 0, o, a);
								}),
								n
							);
						}),
						(t.wrapProgram = r),
						(t.resolvePartial = function (e, t, n) {
							return (
								e
									? e.call || n.name || ((n.name = e), (e = n.partials[e]))
									: (e =
											"@partial-block" === n.name
												? n.data["partial-block"]
												: n.partials[n.name]),
								e
							);
						}),
						(t.invokePartial = function (e, t, n) {
							var r = n.data && n.data["partial-block"];
							(n.partial = !0),
								n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
							var a = void 0;
							if (
								(n.fn &&
									n.fn !== o &&
									(function () {
										n.data = d.createFrame(n.data);
										var e = n.fn;
										(a = n.data["partial-block"] = function (t) {
											var n =
												arguments.length <= 1 || void 0 === arguments[1]
													? {}
													: arguments[1];
											return (
												(n.data = d.createFrame(n.data)),
												(n.data["partial-block"] = r),
												e(t, n)
											);
										}),
											e.partials &&
												(n.partials = p.extend({}, n.partials, e.partials));
									})(),
								void 0 === e && a && (e = a),
								void 0 === e)
							)
								throw new f.default(
									"The partial " + n.name + " could not be found"
								);
							if (e instanceof Function) return e(t, n);
						}),
						(t.noop = o);
					var p = c(n(4)),
						f = s(n(5)),
						d = n(3),
						h = n(9),
						m = n(42),
						y = n(32);
				},
				function (e, t, n) {
					e.exports = { default: n(39), __esModule: !0 };
				},
				function (e, t, n) {
					n(40), (e.exports = n(20).Object.seal);
				},
				function (e, t, n) {
					var r = n(41);
					n(17)("seal", function (e) {
						return function (t) {
							return e && r(t) ? e(t) : t;
						};
					});
				},
				function (e, t) {
					e.exports = function (e) {
						return "object" == Fn(e) ? null !== e : "function" == typeof e;
					};
				},
				function (e, t) {
					(t.__esModule = !0),
						(t.wrapHelper = function (e, t) {
							return "function" != typeof e
								? e
								: function () {
										var n = arguments[arguments.length - 1];
										return (
											(arguments[arguments.length - 1] = t(n)),
											e.apply(this, arguments)
										);
								  };
						});
				},
				function (e, t) {
					(function (n) {
						(t.__esModule = !0),
							(t.default = function (e) {
								var t = void 0 !== n ? n : window,
									r = t.Handlebars;
								e.noConflict = function () {
									return t.Handlebars === e && (t.Handlebars = r), e;
								};
							}),
							(e.exports = t.default);
					}.call(
						t,
						(function () {
							return this;
						})()
					));
				}
			]);
		}),
		wr = n(br),
		Or = (br.Handlebars, Or || {});
	(Or._hb = wr),
		(Or["icons/icon"] = wr.template({
			1: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'    <img src="' +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null !=
								(a = l(n, "iconUrl") || (null != t ? l(t, "iconUrl") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "iconUrl",
									hash: {},
									data: o,
									loc: {
										start: { line: 3, column: 14 },
										end: { line: 3, column: 25 }
									}
							  })
							: a
					) +
					'" alt="" class="Icon-image">\n'
				);
			},
			3: function (e, t, n, r, o) {
				var a =
					e.lookupProperty ||
					function (e, t) {
						if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
					};
				return (
					"    " +
					e.escapeExpression(
						(a(n, "icon") || (t && a(t, "icon")) || e.hooks.helperMissing).call(
							null != t ? t : e.nullContext || {},
							null != t ? a(t, "iconName") : t,
							null != t ? a(t, "complexContentsParams") : t,
							{
								name: "icon",
								hash: {},
								data: o,
								loc: {
									start: { line: 5, column: 4 },
									end: { line: 5, column: 43 }
								}
							}
						)
					) +
					"\n"
				);
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u = e.hooks.helperMissing,
					c = e.escapeExpression,
					s =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'<div class="Icon Icon--' +
					c(
						((l =
							null != (l = s(n, "name") || (null != t ? s(t, "name") : t))
								? l
								: u),
						"function" === Fn(l)
							? l.call(i, {
									name: "name",
									hash: {},
									data: o,
									loc: {
										start: { line: 1, column: 23 },
										end: { line: 1, column: 31 }
									}
							  })
							: l)
					) +
					" " +
					c(
						((l =
							null !=
							(l = s(n, "classNames") || (null != t ? s(t, "classNames") : t))
								? l
								: u),
						"function" === Fn(l)
							? l.call(i, {
									name: "classNames",
									hash: {},
									data: o,
									loc: {
										start: { line: 1, column: 32 },
										end: { line: 1, column: 46 }
									}
							  })
							: l)
					) +
					'" aria-hidden="true">\n' +
					(null !=
					(a = s(n, "if").call(i, null != t ? s(t, "iconUrl") : t, {
						name: "if",
						hash: {},
						fn: e.program(1, o, 0),
						inverse: e.program(3, o, 0),
						data: o,
						loc: { start: { line: 2, column: 2 }, end: { line: 6, column: 9 } }
					}))
						? a
						: "") +
					"</div>\n"
				);
			},
			useData: !0
		})),
		wr.registerPartial("icons/icon", Or["icons/icon"]),
		(Or["search/autocomplete"] = wr.template({
			1: function (e, t, n, r, o, a, l) {
				var i,
					u = null != t ? t : e.nullContext || {},
					c =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'    <div class="yxt-AutoComplete">\n      ' +
					e.escapeExpression(
						(
							c(n, "assign") ||
							(t && c(t, "assign")) ||
							e.hooks.helperMissing
						).call(
							u,
							"currentSelected",
							null != t ? c(t, "sectionIndex") : t,
							null != t ? c(t, "resultIndex") : t,
							{
								name: "assign",
								hash: {},
								data: o,
								loc: {
									start: { line: 4, column: 6 },
									end: { line: 4, column: 59 }
								}
							}
						)
					) +
					"\n" +
					(null !=
					(i = c(n, "if").call(u, null != t ? c(t, "promptHeader") : t, {
						name: "if",
						hash: {},
						fn: e.program(2, o, 0, a, l),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 5, column: 6 },
							end: { line: 11, column: 13 }
						}
					}))
						? i
						: "") +
					(null !=
					(i = c(n, "each").call(u, null != t ? c(t, "sections") : t, {
						name: "each",
						hash: {},
						fn: e.program(4, o, 0, a, l),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 12, column: 6 },
							end: { line: 43, column: 15 }
						}
					}))
						? i
						: "") +
					"    </div>\n"
				);
			},
			2: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'        <ul class="yxt-AutoComplete-results">\n          <li class="yxt-AutoComplete-option yxt-AutoComplete-option--promptHeader">\n            ' +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null !=
								(a =
									l(n, "promptHeader") ||
									(null != t ? l(t, "promptHeader") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "promptHeader",
									hash: {},
									data: o,
									loc: {
										start: { line: 8, column: 12 },
										end: { line: 8, column: 28 }
									}
							  })
							: a
					) +
					"\n          </li>\n        </ul>\n"
				);
			},
			4: function (e, t, n, r, o, a, l) {
				var i,
					u = null != t ? t : e.nullContext || {},
					c =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'        <span class="yxt-AutoComplete-resultsCount sr-only" aria-live="assertive">\n          ' +
					(null !=
					(i = (
						c(n, "processTranslation") ||
						(t && c(t, "processTranslation")) ||
						e.hooks.helperMissing
					).call(u, {
						name: "processTranslation",
						hash: {
							pluralForm1: "[[resultsCount]] autocomplete options found",
							pluralForm0: "[[resultsCount]] autocomplete option found",
							count: null != t ? c(t, "resultsCount") : t,
							resultsCount: null != t ? c(t, "resultsCount") : t
						},
						data: o,
						loc: {
							start: { line: 14, column: 10 },
							end: { line: 19, column: 12 }
						}
					}))
						? i
						: "") +
					'\n        </span>\n        <ul role="listbox"\n            class="yxt-AutoComplete-results"\n            aria-labelledby="' +
					e.escapeExpression(
						e.lambda(null != l[1] ? c(l[1], "listLabelIdName") : l[1], t)
					) +
					'"\n        >\n' +
					(null !=
					(i = c(n, "if").call(u, null != t ? c(t, "label") : t, {
						name: "if",
						hash: {},
						fn: e.program(5, o, 0, a, l),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 25, column: 8 },
							end: { line: 27, column: 15 }
						}
					}))
						? i
						: "") +
					(null !=
					(i = c(n, "each").call(u, null != t ? c(t, "results") : t, {
						name: "each",
						hash: {},
						fn: e.program(7, o, 0, a, l),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 28, column: 8 },
							end: { line: 41, column: 17 }
						}
					}))
						? i
						: "") +
					"        </ul>\n"
				);
			},
			5: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'          <li class="yxt-AutoComplete-resultHeader">' +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null != (a = l(n, "label") || (null != t ? l(t, "label") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "label",
									hash: {},
									data: o,
									loc: {
										start: { line: 26, column: 52 },
										end: { line: 26, column: 61 }
									}
							  })
							: a
					) +
					"</li>\n"
				);
			},
			7: function (e, t, n, r, o, a, l) {
				var i,
					u,
					c = null != t ? t : e.nullContext || {},
					s = e.hooks.helperMissing,
					p = e.escapeExpression,
					f = e.lambda,
					d =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					"          " +
					p(
						(d(n, "assign") || (t && d(t, "assign")) || s).call(
							c,
							"currentIndex",
							e.data(o, 1) && d(e.data(o, 1), "index"),
							o && d(o, "index"),
							{
								name: "assign",
								hash: {},
								data: o,
								loc: {
									start: { line: 29, column: 10 },
									end: { line: 29, column: 52 }
								}
							}
						)
					) +
					'\n          <li class="js-yext-autocomplete-option yxt-AutoComplete-option yxt-AutoComplete-option--item' +
					(null !=
					(i = (d(n, "ifeq") || (t && d(t, "ifeq")) || s).call(
						c,
						null != l[2] ? d(l[2], "currentSelected") : l[2],
						null != l[2] ? d(l[2], "currentIndex") : l[2],
						{
							name: "ifeq",
							hash: {},
							fn: e.program(8, o, 0, a, l),
							inverse: e.noop,
							data: o,
							loc: {
								start: { line: 30, column: 102 },
								end: { line: 30, column: 174 }
							}
						}
					))
						? i
						: "") +
					'"\n              data-value="' +
					p(
						((u =
							null != (u = d(n, "value") || (null != t ? d(t, "value") : t))
								? u
								: s),
						"function" === Fn(u)
							? u.call(c, {
									name: "value",
									hash: {},
									data: o,
									loc: {
										start: { line: 31, column: 26 },
										end: { line: 31, column: 35 }
									}
							  })
							: u)
					) +
					'"\n              data-short="' +
					p(
						((u =
							null !=
							(u = d(n, "shortValue") || (null != t ? d(t, "shortValue") : t))
								? u
								: s),
						"function" === Fn(u)
							? u.call(c, {
									name: "shortValue",
									hash: {},
									data: o,
									loc: {
										start: { line: 32, column: 26 },
										end: { line: 32, column: 40 }
									}
							  })
							: u)
					) +
					"\"\n              data-filter='" +
					p(
						(d(n, "json") || (t && d(t, "json")) || s).call(
							c,
							null != t ? d(t, "filter") : t,
							{
								name: "json",
								hash: {},
								data: o,
								loc: {
									start: { line: 33, column: 27 },
									end: { line: 33, column: 42 }
								}
							}
						)
					) +
					'\'\n              data-eventtype="AUTO_COMPLETE_SELECTION"\n              data-eventoptions=\'{"suggestedSearchText": "' +
					p(
						((u =
							null != (u = d(n, "value") || (null != t ? d(t, "value") : t))
								? u
								: s),
						"function" === Fn(u)
							? u.call(c, {
									name: "value",
									hash: {},
									data: o,
									loc: {
										start: { line: 35, column: 58 },
										end: { line: 35, column: 67 }
									}
							  })
							: u)
					) +
					'"}\'\n              role="option"\n              id="yxt-AutoComplete-option-' +
					p(
						f(
							null != (i = null != l[2] ? d(l[2], "_config") : l[2])
								? d(i, "name")
								: i,
							t
						)
					) +
					"-" +
					p(f(e.data(o, 1) && d(e.data(o, 1), "index"), t)) +
					"-" +
					p(
						((u = null != (u = d(n, "index") || (o && d(o, "index"))) ? u : s),
						"function" === Fn(u)
							? u.call(c, {
									name: "index",
									hash: {},
									data: o,
									loc: {
										start: { line: 37, column: 79 },
										end: { line: 37, column: 89 }
									}
							  })
							: u)
					) +
					'"\n          >\n              ' +
					p(
						(d(n, "highlightValue") || (t && d(t, "highlightValue")) || s).call(
							c,
							t,
							!0,
							{
								name: "highlightValue",
								hash: {},
								data: o,
								loc: {
									start: { line: 39, column: 14 },
									end: { line: 39, column: 42 }
								}
							}
						)
					) +
					"\n          </li>\n"
				);
			},
			8: function (e, t, n, r, o) {
				return " yxt-selected";
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o, a, l) {
				var i,
					u,
					c = null != t ? t : e.nullContext || {},
					s =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'<div class="yxt-AutoComplete-wrapper js-yxt-AutoComplete-wrapper" aria-expanded="' +
					e.escapeExpression(
						"function" ==
							typeof (u =
								null !=
								(u = s(n, "hasResults") || (null != t ? s(t, "hasResults") : t))
									? u
									: e.hooks.helperMissing)
							? u.call(c, {
									name: "hasResults",
									hash: {},
									data: o,
									loc: {
										start: { line: 1, column: 81 },
										end: { line: 1, column: 95 }
									}
							  })
							: u
					) +
					'">\n' +
					(null !=
					(i = s(n, "if").call(c, null != t ? s(t, "hasResults") : t, {
						name: "if",
						hash: {},
						fn: e.program(1, o, 0, a, l),
						inverse: e.noop,
						data: o,
						loc: { start: { line: 2, column: 2 }, end: { line: 45, column: 9 } }
					}))
						? i
						: "") +
					"</div>\n"
				);
			},
			useData: !0,
			useDepths: !0
		})),
		wr.registerPartial("search/autocomplete", Or["search/autocomplete"]),
		(Or["search/filtersearch"] = wr.template({
			1: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'placeholder="' +
					e.escapeExpression(
						e.lambda(
							null != (a = null != t ? l(t, "_config") : t)
								? l(a, "placeholderText")
								: a,
							t
						)
					) +
					'"'
				);
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u = e.hooks.helperMissing,
					c = e.escapeExpression,
					s =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					"<h1>" +
					c(
						((l =
							null != (l = s(n, "title") || (null != t ? s(t, "title") : t))
								? l
								: u),
						"function" === Fn(l)
							? l.call(i, {
									name: "title",
									hash: {},
									data: o,
									loc: {
										start: { line: 1, column: 4 },
										end: { line: 1, column: 13 }
									}
							  })
							: l)
					) +
					'</h1>\n<div class="yext-search-container">\n  <label for="query">' +
					c(
						((l =
							null !=
							(l = s(n, "searchText") || (null != t ? s(t, "searchText") : t))
								? l
								: u),
						"function" === Fn(l)
							? l.call(i, {
									name: "searchText",
									hash: {},
									data: o,
									loc: {
										start: { line: 3, column: 21 },
										end: { line: 3, column: 35 }
									}
							  })
							: l)
					) +
					'</label>\n  <input class="js-yext-query"\n         type="text"\n         name="query"\n         value="' +
					c(
						((l =
							null != (l = s(n, "query") || (null != t ? s(t, "query") : t))
								? l
								: u),
						"function" === Fn(l)
							? l.call(i, {
									name: "query",
									hash: {},
									data: o,
									loc: {
										start: { line: 7, column: 16 },
										end: { line: 7, column: 25 }
									}
							  })
							: l)
					) +
					'"\n         ' +
					(null !=
					(a = s(n, "if").call(
						i,
						null != (a = null != t ? s(t, "_config") : t)
							? s(a, "placeholderText")
							: a,
						{
							name: "if",
							hash: {},
							fn: e.program(1, o, 0),
							inverse: e.noop,
							data: o,
							loc: {
								start: { line: 8, column: 9 },
								end: { line: 8, column: 88 }
							}
						}
					))
						? a
						: "") +
					'>\n  </input>\n  <div class="yxt-SearchBar-autocomplete"></div>\n</div>\n'
				);
			},
			useData: !0
		})),
		wr.registerPartial("search/filtersearch", Or["search/filtersearch"]),
		(Or["search/locationbias"] = wr.template({
			1: function (e, t, n, r, o) {
				return 'style="display:none"';
			},
			3: function (e, t, n, r, o) {
				return "yxt-locationBias-preciseLoc";
			},
			5: function (e, t, n, r, o) {
				return " yxt-LocationBias-unknownLoc ";
			},
			7: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					"(" +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null !=
								(a =
									l(n, "accuracyText") ||
									(null != t ? l(t, "accuracyText") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "accuracyText",
									hash: {},
									data: o,
									loc: {
										start: { line: 6, column: 66 },
										end: { line: 6, column: 82 }
									}
							  })
							: a
					) +
					")"
				);
			},
			9: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'| <button class="js-locationBias-update-location yxt-locationBias-updateLoc">' +
					e.escapeExpression(
						e.lambda(
							null != (a = null != t ? l(t, "_config") : t)
								? l(a, "updateLocationButtonText")
								: a,
							t
						)
					) +
					"</button>"
				);
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'<div class="yxt-LocationBias" ' +
					(null !=
					(a = u(n, "unless").call(i, null != t ? u(t, "shouldShow") : t, {
						name: "unless",
						hash: {},
						fn: e.program(1, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 1, column: 30 },
							end: { line: 1, column: 83 }
						}
					}))
						? a
						: "") +
					'>\n  <div class="yxt-LocationBias-container">\n    <span class="yxt-locationBias-bullet ' +
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "isPreciseLocation") : t, {
						name: "if",
						hash: {},
						fn: e.program(3, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 3, column: 41 },
							end: { line: 3, column: 100 }
						}
					}))
						? a
						: "") +
					" \n    " +
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "isUnknownLocation") : t, {
						name: "if",
						hash: {},
						fn: e.program(5, o, 0),
						inverse: e.noop,
						data: o,
						loc: { start: { line: 4, column: 4 }, end: { line: 4, column: 65 } }
					}))
						? a
						: "") +
					'"></span>\n    <strong>' +
					e.escapeExpression(
						"function" ==
							typeof (l =
								null !=
								(l =
									u(n, "locationDisplayName") ||
									(null != t ? u(t, "locationDisplayName") : t))
									? l
									: e.hooks.helperMissing)
							? l.call(i, {
									name: "locationDisplayName",
									hash: {},
									data: o,
									loc: {
										start: { line: 5, column: 12 },
										end: { line: 5, column: 35 }
									}
							  })
							: l
					) +
					'</strong> \n    <span class="yxt-locationBias-locSource">' +
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "accuracyText") : t, {
						name: "if",
						hash: {},
						fn: e.program(7, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 6, column: 45 },
							end: { line: 6, column: 90 }
						}
					}))
						? a
						: "") +
					" " +
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "allowUpdate") : t, {
						name: "if",
						hash: {},
						fn: e.program(9, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 6, column: 91 },
							end: { line: 6, column: 239 }
						}
					}))
						? a
						: "") +
					"</span>\n  </div>\n</div>"
				);
			},
			useData: !0
		})),
		wr.registerPartial("search/locationbias", Or["search/locationbias"]),
		(Or["search/search"] = wr.template({
			1: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'  <h1 class="yxt-SearchBar-title">' +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null != (a = l(n, "title") || (null != t ? l(t, "title") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "title",
									hash: {},
									data: o,
									loc: {
										start: { line: 4, column: 34 },
										end: { line: 4, column: 43 }
									}
							  })
							: a
					) +
					"</h1>\n"
				);
			},
			3: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u = e.hooks.helperMissing,
					c = "function",
					s = e.escapeExpression,
					p =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'      <form class="yxt-SearchBar-form">\n        <label class="sr-only" \n               for="' +
					s(
						((l =
							null !=
							(l = p(n, "inputIdName") || (null != t ? p(t, "inputIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 11, column: 20 },
										end: { line: 11, column: 35 }
									}
							  })
							: l)
					) +
					'"\n               id="' +
					s(
						((l =
							null !=
							(l =
								p(n, "inputLabelIdName") ||
								(null != t ? p(t, "inputLabelIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputLabelIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 12, column: 19 },
										end: { line: 12, column: 39 }
									}
							  })
							: l)
					) +
					'"\n        >\n          ' +
					s(
						((l =
							null !=
							(l = p(n, "labelText") || (null != t ? p(t, "labelText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "labelText",
									hash: {},
									data: o,
									loc: {
										start: { line: 14, column: 10 },
										end: { line: 14, column: 23 }
									}
							  })
							: l)
					) +
					'\n        </label>\n        <input class="js-yext-query yxt-SearchBar-input"\n          id="' +
					s(
						((l =
							null !=
							(l = p(n, "inputIdName") || (null != t ? p(t, "inputIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 17, column: 14 },
										end: { line: 17, column: 29 }
									}
							  })
							: l)
					) +
					'"\n          type="text"\n          name="query"\n          value="' +
					s(
						((l =
							null != (l = p(n, "query") || (null != t ? p(t, "query") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "query",
									hash: {},
									data: o,
									loc: {
										start: { line: 20, column: 17 },
										end: { line: 20, column: 26 }
									}
							  })
							: l)
					) +
					'"\n          ' +
					(null !=
					(a = p(n, "if").call(
						i,
						null != (a = null != t ? p(t, "_config") : t)
							? p(a, "placeholderText")
							: a,
						{
							name: "if",
							hash: {},
							fn: e.program(4, o, 0),
							inverse: e.noop,
							data: o,
							loc: {
								start: { line: 21, column: 10 },
								end: { line: 21, column: 89 }
							}
						}
					))
						? a
						: "") +
					'\n          aria-label="' +
					s(
						((l =
							null !=
							(l = p(n, "labelText") || (null != t ? p(t, "labelText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "labelText",
									hash: {},
									data: o,
									loc: {
										start: { line: 22, column: 22 },
										end: { line: 22, column: 35 }
									}
							  })
							: l)
					) +
					'"\n          aria-autocomplete="list"\n          aria-controls="' +
					s(
						((l =
							null !=
							(l =
								p(n, "autocompleteContainerIdName") ||
								(null != t ? p(t, "autocompleteContainerIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "autocompleteContainerIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 24, column: 25 },
										end: { line: 24, column: 56 }
									}
							  })
							: l)
					) +
					'"\n          aria-haspopup="listbox"\n        >\n        <button type="button"\n                class="js-yxt-SearchBar-clear yxt-SearchBar-clear yxt-SearchBar--hidden"\n                data-eventtype="SEARCH_CLEAR_BUTTON"\n                data-eventoptions="' +
					s(
						((l =
							null !=
							(l =
								p(n, "eventOptions") || (null != t ? p(t, "eventOptions") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "eventOptions",
									hash: {},
									data: o,
									loc: {
										start: { line: 30, column: 35 },
										end: { line: 30, column: 51 }
									}
							  })
							: l)
					) +
					'"\n                data-component="IconComponent"\n                data-opts=\'{ "iconName": "close" }\'\n                data-prop="icon"\n        >\n          <span class="yxt-SearchBar-clearButtonText sr-only">\n            ' +
					s(
						((l =
							null !=
							(l = p(n, "clearText") || (null != t ? p(t, "clearText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "clearText",
									hash: {},
									data: o,
									loc: {
										start: { line: 36, column: 12 },
										end: { line: 36, column: 25 }
									}
							  })
							: l)
					) +
					"\n          </span>\n        </button>\n        <button " +
					(null !=
					(a = p(n, "if").call(i, null != t ? p(t, "useForm") : t, {
						name: "if",
						hash: {},
						fn: e.program(6, o, 0),
						inverse: e.program(8, o, 0),
						data: o,
						loc: {
							start: { line: 39, column: 16 },
							end: { line: 39, column: 72 }
						}
					}))
						? a
						: "") +
					'\n          class="js-yext-submit yxt-SearchBar-button">\n' +
					(null !=
					(a = p(n, "if").call(i, null != t ? p(t, "submitIcon") : t, {
						name: "if",
						hash: {},
						fn: e.program(10, o, 0),
						inverse: e.program(12, o, 0),
						data: o,
						loc: {
							start: { line: 41, column: 10 },
							end: { line: 62, column: 17 }
						}
					}))
						? a
						: "") +
					'          <span class="yxt-SearchBar-buttonText sr-only">\n            ' +
					s(
						((l =
							null !=
							(l = p(n, "submitText") || (null != t ? p(t, "submitText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "submitText",
									hash: {},
									data: o,
									loc: {
										start: { line: 64, column: 12 },
										end: { line: 64, column: 26 }
									}
							  })
							: l)
					) +
					"\n          </span>\n        </button>\n      </form>\n"
				);
			},
			4: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'placeholder="' +
					e.escapeExpression(
						e.lambda(
							null != (a = null != t ? l(t, "_config") : t)
								? l(a, "placeholderText")
								: a,
							t
						)
					) +
					'"'
				);
			},
			6: function (e, t, n, r, o) {
				return 'type="submit"';
			},
			8: function (e, t, n, r, o) {
				return 'type="button"';
			},
			10: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'            <div class="yxt-SearchBar-buttonImage"\n                data-component="IconComponent"\n                data-opts=\'{ "iconName": "' +
					e.escapeExpression(
						"function" ==
							typeof (a =
								null !=
								(a = l(n, "submitIcon") || (null != t ? l(t, "submitIcon") : t))
									? a
									: e.hooks.helperMissing)
							? a.call(null != t ? t : e.nullContext || {}, {
									name: "submitIcon",
									hash: {},
									data: o,
									loc: {
										start: { line: 44, column: 42 },
										end: { line: 44, column: 56 }
									}
							  })
							: a
					) +
					"\" }'\n            ></div>\n"
				);
			},
			12: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return null !=
					(a = l(n, "if").call(
						null != t ? t : e.nullContext || {},
						null != (a = null != t ? l(t, "_config") : t)
							? l(a, "customIconUrl")
							: a,
						{
							name: "if",
							hash: {},
							fn: e.program(13, o, 0),
							inverse: e.program(15, o, 0),
							data: o,
							loc: {
								start: { line: 46, column: 10 },
								end: { line: 62, column: 10 }
							}
						}
					))
					? a
					: "";
			},
			13: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'            <div class="yxt-SearchBar-buttonImage"\n                data-component="IconComponent"\n                data-opts=\'{ "iconUrl": "' +
					e.escapeExpression(
						e.lambda(
							null != (a = null != t ? l(t, "_config") : t)
								? l(a, "customIconUrl")
								: a,
							t
						)
					) +
					"\" }'\n            ></div>\n"
				);
			},
			15: function (e, t, n, r, o) {
				var a,
					l = null != t ? t : e.nullContext || {},
					i = e.hooks.helperMissing,
					u = e.escapeExpression,
					c =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'            <div class="yxt-SearchBar-AnimatedIcon yxt-SearchBar-AnimatedIcon--paused js-yxt-AnimatedForward\n              ' +
					(null !=
					(a = c(n, "if").call(l, null != t ? c(t, "autoFocus") : t, {
						name: "if",
						hash: {},
						fn: e.program(16, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 53, column: 14 },
							end: { line: 53, column: 75 }
						}
					}))
						? a
						: "") +
					'"\n              data-component="IconComponent"\n              data-opts="' +
					u(
						(c(n, "json") || (t && c(t, "json")) || i).call(
							l,
							null != t ? c(t, "forwardIconOpts") : t,
							{
								name: "json",
								hash: {},
								data: o,
								loc: {
									start: { line: 55, column: 25 },
									end: { line: 55, column: 49 }
								}
							}
						)
					) +
					'">\n            </div>\n            <div class="yxt-SearchBar-AnimatedIcon yxt-SearchBar-AnimatedIcon--paused js-yxt-AnimatedReverse\n              ' +
					(null !=
					(a = c(n, "unless").call(l, null != t ? c(t, "autoFocus") : t, {
						name: "unless",
						hash: {},
						fn: e.program(16, o, 0),
						inverse: e.noop,
						data: o,
						loc: {
							start: { line: 58, column: 14 },
							end: { line: 58, column: 83 }
						}
					}))
						? a
						: "") +
					'"\n              data-component="IconComponent"\n              data-opts="' +
					u(
						(c(n, "json") || (t && c(t, "json")) || i).call(
							l,
							null != t ? c(t, "reverseIconOpts") : t,
							{
								name: "json",
								hash: {},
								data: o,
								loc: {
									start: { line: 60, column: 25 },
									end: { line: 60, column: 49 }
								}
							}
						)
					) +
					'">\n            </div>\n          '
				);
			},
			16: function (e, t, n, r, o) {
				return " yxt-SearchBar-AnimatedIcon--inactive";
			},
			18: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u = e.hooks.helperMissing,
					c = "function",
					s = e.escapeExpression,
					p =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'      <div class="yxt-SearchBar-input-wrapper">\n        <label class="sr-only" \n               for="' +
					s(
						((l =
							null !=
							(l = p(n, "inputIdName") || (null != t ? p(t, "inputIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 71, column: 20 },
										end: { line: 71, column: 35 }
									}
							  })
							: l)
					) +
					'"\n               id="' +
					s(
						((l =
							null !=
							(l =
								p(n, "inputLabelIdName") ||
								(null != t ? p(t, "inputLabelIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputLabelIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 72, column: 19 },
										end: { line: 72, column: 39 }
									}
							  })
							: l)
					) +
					'"\n        >\n          ' +
					s(
						((l =
							null !=
							(l = p(n, "labelText") || (null != t ? p(t, "labelText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "labelText",
									hash: {},
									data: o,
									loc: {
										start: { line: 74, column: 10 },
										end: { line: 74, column: 23 }
									}
							  })
							: l)
					) +
					'\n        </label>\n        <input class="js-yext-query yxt-SearchBar-input"\n          id="' +
					s(
						((l =
							null !=
							(l = p(n, "inputIdName") || (null != t ? p(t, "inputIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "inputIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 77, column: 14 },
										end: { line: 77, column: 29 }
									}
							  })
							: l)
					) +
					'"\n          type="text"\n          name="query"\n          value="' +
					s(
						((l =
							null != (l = p(n, "query") || (null != t ? p(t, "query") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "query",
									hash: {},
									data: o,
									loc: {
										start: { line: 80, column: 17 },
										end: { line: 80, column: 26 }
									}
							  })
							: l)
					) +
					'"\n          ' +
					(null !=
					(a = p(n, "if").call(
						i,
						null != (a = null != t ? p(t, "_config") : t)
							? p(a, "placeholderText")
							: a,
						{
							name: "if",
							hash: {},
							fn: e.program(4, o, 0),
							inverse: e.noop,
							data: o,
							loc: {
								start: { line: 81, column: 10 },
								end: { line: 81, column: 89 }
							}
						}
					))
						? a
						: "") +
					'\n          aria-label="' +
					s(
						((l =
							null !=
							(l = p(n, "labelText") || (null != t ? p(t, "labelText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "labelText",
									hash: {},
									data: o,
									loc: {
										start: { line: 82, column: 22 },
										end: { line: 82, column: 35 }
									}
							  })
							: l)
					) +
					'"\n          aria-autocomplete="list"\n          aria-controls="' +
					s(
						((l =
							null !=
							(l =
								p(n, "autocompleteContainerIdName") ||
								(null != t ? p(t, "autocompleteContainerIdName") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "autocompleteContainerIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 84, column: 25 },
										end: { line: 84, column: 56 }
									}
							  })
							: l)
					) +
					'"\n          aria-haspopup="listbox"\n        >\n        <button type="button"\n                class="js-yxt-SearchBar-clear yxt-SearchBar-clear yxt-SearchBar--hidden"\n                data-eventtype="SEARCH_CLEAR_BUTTON"\n                data-eventoptions="' +
					s(
						((l =
							null !=
							(l =
								p(n, "eventOptions") || (null != t ? p(t, "eventOptions") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "eventOptions",
									hash: {},
									data: o,
									loc: {
										start: { line: 90, column: 35 },
										end: { line: 90, column: 51 }
									}
							  })
							: l)
					) +
					'"\n                data-component="IconComponent"\n                data-opts=\'{ "iconName": "close" }\'\n                data-prop="icon"\n        >\n          <span class="yxt-SearchBar-clearButtonText sr-only">\n            ' +
					s(
						((l =
							null !=
							(l = p(n, "clearText") || (null != t ? p(t, "clearText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "clearText",
									hash: {},
									data: o,
									loc: {
										start: { line: 96, column: 12 },
										end: { line: 96, column: 25 }
									}
							  })
							: l)
					) +
					"\n          </span>\n        </button>\n        <button " +
					(null !=
					(a = p(n, "if").call(i, null != t ? p(t, "useForm") : t, {
						name: "if",
						hash: {},
						fn: e.program(6, o, 0),
						inverse: e.program(8, o, 0),
						data: o,
						loc: {
							start: { line: 99, column: 16 },
							end: { line: 99, column: 72 }
						}
					}))
						? a
						: "") +
					'\n          class="js-yext-submit yxt-SearchBar-button">\n' +
					(null !=
					(a = p(n, "if").call(i, null != t ? p(t, "submitIcon") : t, {
						name: "if",
						hash: {},
						fn: e.program(10, o, 0),
						inverse: e.program(12, o, 0),
						data: o,
						loc: {
							start: { line: 101, column: 10 },
							end: { line: 122, column: 17 }
						}
					}))
						? a
						: "") +
					'          <span class="yxt-SearchBar-buttonText sr-only">\n            ' +
					s(
						((l =
							null !=
							(l = p(n, "submitText") || (null != t ? p(t, "submitText") : t))
								? l
								: u),
						Fn(l) === c
							? l.call(i, {
									name: "submitText",
									hash: {},
									data: o,
									loc: {
										start: { line: 124, column: 12 },
										end: { line: 124, column: 26 }
									}
							  })
							: l)
					) +
					"\n          </span>\n        </button>\n      </div>\n"
				);
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o) {
				var a,
					l,
					i = null != t ? t : e.nullContext || {},
					u =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "title") : t, {
						name: "if",
						hash: {},
						fn: e.program(1, o, 0),
						inverse: e.noop,
						data: o,
						loc: { start: { line: 3, column: 0 }, end: { line: 5, column: 7 } }
					}))
						? a
						: "") +
					'<div class="yxt-SearchBar">\n  <div class="yxt-SearchBar-container">\n' +
					(null !=
					(a = u(n, "if").call(i, null != t ? u(t, "useForm") : t, {
						name: "if",
						hash: {},
						fn: e.program(3, o, 0),
						inverse: e.program(18, o, 0),
						data: o,
						loc: {
							start: { line: 8, column: 4 },
							end: { line: 128, column: 11 }
						}
					}))
						? a
						: "") +
					'    <div id="' +
					e.escapeExpression(
						"function" ==
							typeof (l =
								null !=
								(l =
									u(n, "autocompleteContainerIdName") ||
									(null != t ? u(t, "autocompleteContainerIdName") : t))
									? l
									: e.hooks.helperMissing)
							? l.call(i, {
									name: "autocompleteContainerIdName",
									hash: {},
									data: o,
									loc: {
										start: { line: 129, column: 13 },
										end: { line: 129, column: 44 }
									}
							  })
							: l
					) +
					'" class="yxt-SearchBar-autocomplete"></div>\n  </div>\n</div>\n'
				);
			},
			useData: !0
		})),
		wr.registerPartial("search/search", Or["search/search"]),
		(Or["search/spellcheck"] = wr.template({
			1: function (e, t, n, r, o) {
				var a,
					l = null != t ? t : e.nullContext || {},
					i = e.hooks.helperMissing,
					u = e.escapeExpression,
					c =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return (
					'  <div class="yxt-SpellCheck">\n    <div class="yxt-SpellCheck-container">\n      <span class="yxt-SpellCheck-helpText">' +
					u(
						((a =
							null !=
							(a = c(n, "helpText") || (null != t ? c(t, "helpText") : t))
								? a
								: i),
						"function" === Fn(a)
							? a.call(l, {
									name: "helpText",
									hash: {},
									data: o,
									loc: {
										start: { line: 4, column: 44 },
										end: { line: 4, column: 56 }
									}
							  })
							: a)
					) +
					'</span>\n      <a href="' +
					u(
						((a =
							null !=
							(a =
								c(n, "correctedQueryUrl") ||
								(null != t ? c(t, "correctedQueryUrl") : t))
								? a
								: i),
						"function" === Fn(a)
							? a.call(l, {
									name: "correctedQueryUrl",
									hash: {},
									data: o,
									loc: {
										start: { line: 5, column: 15 },
										end: { line: 5, column: 36 }
									}
							  })
							: a)
					) +
					'">\n        ' +
					u(
						(c(n, "highlightValue") || (t && c(t, "highlightValue")) || i).call(
							l,
							null != t ? c(t, "correctedQuery") : t,
							!1,
							{
								name: "highlightValue",
								hash: {},
								data: o,
								loc: {
									start: { line: 6, column: 8 },
									end: { line: 6, column: 47 }
								}
							}
						)
					) +
					"\n      </a>\n    </div>\n  </div>\n"
				);
			},
			compiler: [8, ">= 4.3.0"],
			main: function (e, t, n, r, o) {
				var a,
					l =
						e.lookupProperty ||
						function (e, t) {
							if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
						};
				return null !=
					(a = l(n, "if").call(
						null != t ? t : e.nullContext || {},
						null != t ? l(t, "shouldShow") : t,
						{
							name: "if",
							hash: {},
							fn: e.program(1, o, 0),
							inverse: e.noop,
							data: o,
							loc: {
								start: { line: 1, column: 0 },
								end: { line: 10, column: 7 }
							}
						}
					))
					? a
					: "";
			},
			useData: !0
		})),
		wr.registerPartial("search/spellcheck", Or["search/spellcheck"]);
	window.ANSWERS && window.ANSWERS.templates && ANSWERS.templates.register(Or);
	(e.default = Or), Object.defineProperty(e, "__esModule", { value: !0 });
});
